
<template xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
    <div id="app2" :style="{ background: this.isActive == false ? bgColor : '#373e57',width:screenWidth }"  > <!--linear-gradient(90deg, #434343 0%,black 100%)   白色 #f5f7f9  黑色 #373e57-->
        <vue-canvas-nest v-if="this.electronicEquipment == true" :config="{ color: '255,255,255', count: 100 }"></vue-canvas-nest>
        <div id="app3">
          <ColorPicker v-model="bgColor" alpha @on-change="changeBg" />
          <headers></headers>
          <div id="box">
            <!--        id="left"    -->
            <div >

              <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" >
                <template #title >
                  <Icon type="ios-contact" size="18" />
                  {{ user.name }}
                </template>
<!--                <p slot="title">
                  &lt;!&ndash; 用户名字 暂时还没写修改的 函数名editName &ndash;&gt;

                </p>-->
                <Poptip slot="extra" content="可同步更新角色活动属性" placement="top-start" style="margin: 0 5px" >
                  <Button  size="small" @click="updateAllcharacter" type="info" >
                    同步
                  </Button>
                </Poptip>
                <Button slot="extra" @click.prevent="editName" size="small" type="info" ghost>
                  修改名字
                </Button>
                <div>
                  <div class="character">
                    <Upload type="drag" :before-upload="handleUpload" action="http://www.yunyingxiaowu.com:8088/foodie-api/gamepassport/uploadFace">
                      <div style="width: 100px; height: 100px; overflow: hidden">
                        <p class="touxiang" :style="{ backgroundImage: 'url(' + this.userActivity.face + ')' }"></p>
                      </div>
                    </Upload>
                    <!-- <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" /> -->
                    <div class="rank">
                      <div>
                        <span style="float: left">LV {{ userActivity.level }}</span>
                        <span style="float: left;margin-left: 10px" >{{user.realmName}}</span>
                        <span style="float: right">编号{{ user.accountId }}</span>
                      </div>
                      <div class="bloodVolume">生命: {{ user.health }} </div>
                      <div class="blueAmount">真气值: {{ user.mana }}</div>
                      <div style="margin: 10px 0"><Progress  :percent="(userActivity.baifbi*100).toFixed(2)" :stroke-width="20" text-inside :stroke-color="['#f90', '#f90']" /></div>
                    </div>
                  </div>
                  <div class="goldCoin" >
                    <div  v-if="!isActive"> <p><Tag type="border" > 当前等级经验: {{ userActivity.exp }} / {{ userActivity.upgradeExp }}</Tag></p>
                      <!-- 金币买普通物品 -->
                      <p ><Tag type="border">当前金币:{{ userActivity.money }}</Tag></p>
                      <p><Tag type="border">当前灵石: {{ userActivity.coin }}</Tag></p>
                      <p><Tag type="border">副本奖励次数: {{ userActivity.rewardNum }}</Tag></p>
                      <p><Tag type="border">金币本奖励次数: {{ userActivity.activityRewardNum }}</Tag></p>
                      <p><Tag type="border">锁妖塔通关层数: {{ userActivity.mapName }}</Tag></p>
                      <p><Tag type="border">贡献点: {{ userActivity.contriPoint }}</Tag></p></div>
                    <div  v-if="isActive">
                      <p> 当前等级经验: {{ userActivity.exp }} / {{ userActivity.upgradeExp }}</p>
                      <!-- 金币买普通物品 -->
                      <p> 当前金币:{{ userActivity.money }}</p>
                      <p> 当前灵石: {{ userActivity.coin }}</p>
                      <p> 副本奖励次数: {{ userActivity.rewardNum }}</p>
                      <p> 金币本奖励次数: {{ userActivity.activityRewardNum }}</p>
                      <p> 锁妖塔通关层数: {{ userActivity.mapName }}</p>
                      <p> 贡献点: {{ userActivity.contriPoint }}</p></div>
                    <p>
                      <Tag type="border"  v-if="!isActive" >境 界</Tag>
                      <Tag color="#373e57" size="large" v-if="isActive" >境 界</Tag>
<!--                      <Poptip trigger="hover" :title="user.realmName" @on-popper-show="getRealmAttribute">-->
                      <Poptip :title="user.realmName" >
                                    <span :style="{
                      color: realmColor,
                      boxShadow: realmShadow,
                      fontSize: '18px',
                    }">
                                        {{ user.realmName }}
                                    </span>
                    <div slot="content" >
                    <p>通过心法修炼层数来进行境界突破</p>
                    </div>
<!--                      <p v-if="realmAttribute.realmAttack">-->
<!--                        <span>真气加成</span>-->
<!--                        {{ (realmAttribute.realmAttack * 100).toFixed(2) || 0 }} %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmMagicAttack">-->
<!--                        <span>灵力攻击加成</span>-->
<!--                        {{-->
<!--                          (realmAttribute.realmMagicAttack * 100).toFixed(2) || 0-->
<!--                        }}-->
<!--                        %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmHealth">-->
<!--                        <span>血量加成</span>-->
<!--                        {{ (realmAttribute.realmHealth * 100).toFixed(2) || 0 }} %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmMana">-->
<!--                        <span>道法加成</span>-->
<!--                        {{ (realmAttribute.realmMana * 100).toFixed(2) || 0 }} %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmDefense">-->
<!--                        <span>防御加成</span>-->
<!--                        {{ (realmAttribute.realmDefense * 100).toFixed(2) || 0 }}-->
<!--                        %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmCriticalHit">-->
<!--                        <span>暴击加成</span>-->
<!--                        {{-->
<!--                          (realmAttribute.realmCriticalHit * 100).toFixed(2) || 0-->
<!--                        }}-->
<!--                        %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmCriticalDamage">-->
<!--                        <span>暴击伤害加成</span>-->
<!--                        {{-->
<!--                          (realmAttribute.realmCriticalDamage * 100).toFixed(2) ||-->
<!--                          0-->
<!--                        }}-->
<!--                        %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmEvade">-->
<!--                        <span>闪避加成</span>-->
<!--                        {{ (realmAttribute.realmEvade * 100).toFixed(2) || 0 }} %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmHitRat">-->
<!--                        <span>命中加成</span>-->
<!--                        {{ (realmAttribute.realmHitRat * 100).toFixed(2) || 0 }} %-->
<!--                      </p>-->
<!--                      <p v-if="realmAttribute.realmSpeed">-->
<!--                        <span>速度加成</span>-->
<!--                        {{ realmAttribute.realmSpeed || 0 }}-->
<!--                      </p>-->
<!--                    </div>-->
                    </Poptip>
                    <Tag type="border"  v-if="!isActive" >修真经验</Tag>
                    <Tag color="#373e57" size="large" v-if="isActive" >修真经验</Tag>
                    &nbsp{{ userActivity.realmExp }} / {{ user.realmUpExp }}
                    <Button size="small" @click="breach" type="primary" >突破</Button>
                    </p>
                  </div>
                </div>
              </Card>
              <!-- 地图和战斗场景 -->
              <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }"  style="   height: 485px;font-family: STXinWei">
                <p slot="title">
                  {{ mapNameF }}
                </p>

                <!-- 批量使用弹出框 -->
                <Modal width="620" title="结算离线" v-model="settlementjectEject" :styles="{ top: '100px' }">
                  <div>
                    总共获得 {{ settlementjectList.countExp }} 经验
                    <br />
                    总共战斗 {{ settlementjectList.combatNum }} 次数
                    <br />
                    总共胜利 {{ settlementjectList.combatSuccessNum }} 次数
                    <br />
                    获得 {{ settlementjectList.countItemNum }} 个物品
                    <br />
                    自动出售 {{ settlementjectList.countSellNum }} 个数量
                    <br />
                    总共获得 {{ settlementjectList.countMoney }} 金币
                    <br />
                    {{ settlementjectList.outboardTime }}
                  </div>
                </Modal>
                <Button slot="extra" @click.prevent="palyerNote" style="margin-left: 140px"  @click="noteFlag = true" size="small" type="info" ghost>修仙日志</Button>
                <Drawer width="320px" title="修仙之路" :closable="false" v-model="noteFlag">
                  <Input v-model="inputKeyWord" placeholder="关键字查询" style="margin-left:20px;margin-bottom:20px;width: auto" clearable/>
                  <Button type="primary" @click="palyerNote" style="margin-bottom:20px;width: auto" >查询</Button>
                  <Timeline  v-for="(item, index) in palyerNoteList"
                             :key="index"
                             style="margin-bottom: 4px" >
                    <TimelineItem   :color="item.color"  >
                      <p class="time" style="font-size: small;">{{ addEightHours(item.date) }}</p>
                      <p class="content" v-html="item.noteDesc" style="white-space:pre-wrap"> {{ item.noteDesc }}</p>
                    </TimelineItem>
                  </Timeline>
                </Drawer>
                <Button slot="extra"  style="margin-left: 10px" @click.prevent="palyerNote2"  @click="dropFlag = true" size="small" type="info" ghost>地图掉落</Button>
                <Drawer  title="地图掉落"  width="640"  :closable="false" v-model="dropFlag">
                  <p v-for="(mapLoots, index) in mapLootsList" :key="index">
                    <Breadcrumb style="font-size: 20px;padding-top: 20px">
                      <BreadcrumbItem to="/">
                        <Icon type="ios-home-outline"></Icon>   {{ mapLoots.mapName }}
                      </BreadcrumbItem>
                      <BreadcrumbItem to="/components/breadcrumb">
                        <Icon type="logo-buffer"></Icon>   {{ mapLoots.mapMinLv }} -   {{ mapLoots.mapMaxLv }}
                      </BreadcrumbItem>
                    </Breadcrumb>
                  <Table stripe :columns="columns" :data="mapLoots.itemsVoList"></Table>
                  <!--                                      <template v-if="mapLoots.itemsVoList">-->
                  <!--                                          <span v-for="(loot, idx) in mapLoots.itemsVoList" :key="idx">-->
                  <!--                                              <template v-if="loot">-->
                  <!--                                                  <span :style="{ color: distinguishColor(loot.color) }">-->
                  <!--                                                      {{ loot.itemName }}-->
                  <!--                                                  </span>-->
                  <!--                                              </template>-->
                  <!--                                          </span>-->
                  <!--                                      </template>-->
                  </p>
                </Drawer>
                <!-- changeMap -->
                <Button style="margin-left: 10px;margin-right: 10px" slot="extra" @click.prevent="reverseOffLine" size="small" type="success">
                  {{ this.userActivity.online == 0 ? "开始离线" : "结算离线" }}
                </Button>
                <Button slot="extra"  @click="value2 = true" size="small" type="info" >地图选择</Button>
                <Button style="margin-left: 140px;margin-top: 10px" slot="extra" @click.prevent="withdrawFromAction" size="small" type="warning" :loading="withdrawFromActionStatus">
                  退出战斗
                </Button>
                <Button style="margin-left: 10px;margin-top: 10px" slot="extra" @click.prevent="
              withdrawFromActionStatus = false;
              deteSetMap();
            " size="small" type="info" ghost>
                  确定
                </Button>

                <modal width="920px"   v-model="value2" footer-hide="true" :styles="{ top: '100px' }">
                  <Collapse v-model="collValue"  accordion>
                    <Panel name="1">
                      人间境
                      <template #content>
                        <div class="parent1">
                          <div style=" border: 1px solid #abb6c0;" @click="xuanzhong(item.mapName)" :class="'ddiv'+(index+1)" v-for="(item, index) in mapList" :key="index">
                            <span style="padding: 0px 10px" >{{ item.mapName }}</span>
                            <p style="padding: 0px 5px">{{ item.describeTion }}</p>
                            <span style="float:right;color:#ccc;padding: 0px 10px">[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]   在线人数：{{ item.onlineNum }}</span>
                          </div>
                        </div>
                      </template>
                    </Panel>
                    <!--                    <Panel name="2">
                                          组队地图
                                          <template #content>斯蒂夫·盖瑞·沃兹尼亚克（Stephen Gary Wozniak），美国电脑工程师，曾与史蒂夫·乔布斯合伙创立苹果电脑（今之苹果公司）。斯蒂夫·盖瑞·沃兹尼亚克曾就读于美国科罗拉多大学，后转学入美国著名高等学府加州大学伯克利分校（UC Berkeley）并获得电机工程及计算机（EECS）本科学位（1987年）。</template>
                                        </Panel>-->
                    <!--    <Panel name="3">
                       修真地图
                       <template #content>乔纳森·伊夫是一位工业设计师，现任Apple公司设计师兼资深副总裁，英国爵士。他曾参与设计了iPod，iMac，iPhone，iPad等众多苹果产品。除了乔布斯，他是对苹果那些著名的产品最有影响力的人。</template>
                     </Panel>-->
                  </Collapse>
                </modal>
                <!--                <Select v-model="mapName" >
                                  &lt;!&ndash; ({{ item.minLv }}) &ndash;&gt;
                &lt;!&ndash;                  <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId"  :label="item.mapName" >
                                    <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                  </Option>&ndash;&gt;
                                  <OptionGroup label="组队副本" v-if="this.teamStatus == 1">
                                    <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="普通地图" v-if="mapList1 != []">
                                    <Option v-for="item in mapList1" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="挑战地图" v-if="mapList2 != []">
                                    <Option v-for="item in mapList2" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="修真地图" v-if="mapList3 != []">
                                    <Option v-for="item in mapList3" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="金币本" v-if="mapList4 != []">
                                    <Option v-for="item in mapList4" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="活动地图" v-if="mapList5 != []">
                                    <Option v-for="item in mapList5" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="Boss" v-if="mapList6 != []">
                                    <Option v-for="item in mapList6" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                  <OptionGroup label="真灵地图" v-if="mapList7 != []">
                                    <Option v-for="item in mapList7" :value="item.mapName" :name="item.mapId" :key="item.mapId" :label="item.mapName">
                                      <span>[推荐等级:{{ item.minLv }}-{{ item.maxLv }}]  {{ item.mapName }}</span>
                                      <span style="float:right;color:#ccc">  在线人数：{{ item.onlineNum }}</span>
                                    </Option>
                                  </OptionGroup>
                                </Select>-->
                <div>
                  <div class="monster" :class="[monsterList.length == 1 ? 'monstercenter' : '']">
                    <Poptip trigger="hover" v-for="item in monsterList" :key="item.id" :title="item.name">
                      ({{ item.prefix == 0 ? "无" : item.prefix }}){{ item.name }}
                      <Progress :percent="(Math.max(item.life, 0) / item.maxLife) * 100">
                        <span>{{ item.life }}</span>
                      </Progress>
                      <div slot="content">
                        <p>生命值 {{ item.life }}</p>
                        <p>最小攻击力 {{ item.attackMin }}</p>
                        <p>最大攻击力 {{ item.attackMax }}</p>
                        <p>物理防御力 {{ item.defence }}</p>
                        <p>法术防御力 {{ item.magicDefense }}</p>
                        <p>命中率 {{ item.hitRate * 100 }}%</p>
                        <p>闪避率 {{ item.evade * 100 }}%</p>
                        <p>暴击率 {{ item.explode * 100 }}%</p>
                        <p>暴击伤害 {{ item.criDamage * 100 }}%</p>
                        <p>行动速度 {{ item.speed }}</p>
                        <p style="white-space:pre-wrap;width: 240px">背景： {{ item.monDescri }}</p>
                      </div>
                    </Poptip>
                  </div>
                  <div class="monster" :class="[gameCharacterVO.length == 1 ? 'monstercenter' : '']" v-if="this.teamStatus != 1">
                    <Poptip trigger="hover" v-for="(item,idx) in gameCharacterVO" :key="idx" :title="item.name">
                      角色: {{ item.name || "" }}
                      <br>
                      <Progress :percent="(item.health / item.maxLife) * 100" style="width: 200px">
                        <span>{{ item.health }}</span>
                      </Progress>
                      <div slot="content">
                        <p>生命值 {{ item.health }}</p>
                        <p>物攻 {{ item.physicalAttack }}</p>
                        <p>法攻 {{ item.magicAttack }}</p>
                        <p>物理防御力 {{ item.defense }}</p>
                        <p>法术防御力 {{ item.magicDefense }}</p>
                        <p>命中率 {{ item.hitRate * 100 }}%</p>
                        <p>闪避率 {{ item.evade * 100  || 0}}%</p>
                        <p>暴击率 {{ (item.criticalHitValue * 100).toFixed(2)  || 0}}%</p>
                        <p>暴击伤害 {{ (item.critDamage * 100).toFixed(2) || 0 }}%</p>
                        <p>行动速度 {{ item.movingSpeed }}</p>
                      </div>
                    </Poptip>
                  </div>
                  <div class="monster" :class="[gamePetVOList.length == 1 ? 'monstercenter' : '']" v-if="this.teamStatus != 1">
                    <Poptip trigger="hover" v-for="item in gamePetVOList" :key="item.auraId" :title="item.auraName">
                      ({{ item.auraRace == 0 ? "无" : item.auraRace }}){{ item.auraName }}
                      <Progress :percent="(Math.max(item.auraLife, 0) / item.maxLife) * 100">
                        <span>{{ item.auraLife }}</span>
                      </Progress>
                      <div slot="content">
                        <p>生命值 {{ item.life }}</p>
                        <p>最小攻击力 {{ item.auraAttack }}</p>
                        <p>最大攻击力 {{ item.auraMagicAttack }}</p>
                        <p>物理防御力 {{ item.auraDefence }}</p>
                        <p>法术防御力 {{ item.auraMagicDefence }}</p>
                        <p>命中率 {{ item.auraHitRate * 100 }}%</p>
                        <p>闪避率 {{ item.auraEvade * 100 }}%</p>
                        <p>暴击率 {{ item.auraExplode * 100 }}%</p>
                        <p>暴击伤害 {{ item.auraCalDamage * 100 }}%</p>
                        <p>行动速度 {{ item.auraActionSpeed }}</p>
                      </div>
                    </Poptip>
                  </div>

                  <div class="recording" id="recording">
                    <h6 v-if="monsterList.length <= 0">暂无记录</h6>
                    <battle-process v-bind:recordings="recording"></battle-process>
                  </div>
                </div>
              </Card>
              <!-- 神通 -->
              <skill ></skill>
              <!-- 属性 和 属性加点位置 -->
              <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }"  >
                <p slot="title">
                  属性:
                  <span style="
                border-radius: 50%;
                background: #d9534f;
                padding: 1px 5px;
                color: #fff;
                font-size: 14px;
              ">
                            {{ user.reAttrPoint }}
                        </span>
                </p>
                <!-- 这个确认修改不确定要不要 我想的是买药水然后使用修改 -->
                <Button slot="extra" size="small" @click="setAttribute" type="info" ghost>
                  确认修改
                </Button>
                <div style="overflow: hidden">
                  <div class="basics">
                    <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" >三 神</h6>
                    <p>
                      <Tooltip placement="top">
                        根 骨:
                        <span>{{ user.physique }}</span>
                    <div slot="content">
                      <p>根骨影响生命值和防御力</p>
                    </div>
                    </Tooltip>
                    <button @click="addAttributes(0, 1)">+1</button>
                    <button @click="addAttributes(0, 10)">+10</button>
                    </p>
                    <p>
                      <Tooltip placement="top">
                        力 道:
                        <span>{{ user.dexterous }}</span>
                    <div slot="content">
                      <p>力道影响物理攻击</p>
                    </div>
                    </Tooltip>
                    <button @click="addAttributes(1, 1)">+1</button>
                    <button @click="addAttributes(1, 10)">+10</button>
                    </p>
                    <p>
                      <Tooltip placement="top">
                        灵 力:
                        <span>{{ user.spirit }}</span>
                    <div slot="content">
                      <p>灵力影响真气值和法术攻击</p>
                    </div>
                    </Tooltip>
                    <button @click="addAttributes(2, 1)">+1</button>
                    <button @click="addAttributes(2, 10)">+10</button>
                    </p>
                    <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" style="margin-top: 10px">挂 机</h6>
                    <p>
                      战斗地图:
                      <span>{{ userActivity.outboardMap || '无' }}</span>
                    </p>
                    <p>
                      战斗次数:
                      <span>{{ userActivity.attNum || '无' }}</span>
                    </p>
                    <p>
                      战斗成功次数:
                      <span>{{ userActivity.successNum || '无' }}</span>
                    </p>
                    <p>
                      获取经验:
                      <span>{{ userActivity.outboardExp || '无' }}</span>
                    </p>
                    <p>
                      掉落物品数量:
                      <span>{{ userActivity.dropItem || '无' }}</span>
                    </p>
                    <p>
                      击败数量:
                      <span>{{ userActivity.outboardMonNum || '无' }}</span>
                    </p>
                    <p>
                      战斗时长(参考):
                      <span>{{ userActivity.outboardTime || '无' }}</span>
                    </p>
                    <p>
                      {{ userActivity.outboardDate || '无' }}
                    </p>
                  </div>
                  <div >
                    <div class="basics" style="font-family: Arial,Helvetica,Sans-Serif;">
                      <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" >基础</h6>
                      <p>
                        灵根:
                        <span>{{ user.spiritRootName || '无' }}</span>
                      </p>
                      <p>
                        力道攻击:
                        <span>{{ user.physicalAttack }}</span>
                      </p>
                      <p>
                        灵力攻击:
                        <span>{{ user.magicAttack }}</span>
                      </p>
                      <p>
                        物理防御力:
                        <span>{{ user.defense }}</span>
                      </p>
                      <p>
                        法术防御力:
                        <span>{{ user.magicDefense }}</span>
                      </p>
                      <p>
                        命中率:
                        <span>{{ (user.hitRate * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        闪避率:
                        <span>{{ (user.evade * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        暴击伤害:
                        <span>{{ (user.critDamage * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        行动速度:
                        <span>{{ user.movingSpeed }}</span>
                      </p>
                      <p>
                        额外伤害:
                        <span>{{ (user.additional * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        神通伤害:
                        <span>{{ (user.magical * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        福源:
                        <span>{{ user.lucky || 0 }}</span>
                      </p>
                    </div>
                    <div class="basics" style="font-family: Arial,Helvetica,Sans-Serif;">
                      <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" >高级属性</h6>
                      <p>
                        连击:
                        <span>{{ user.combo }}</span>
                      </p>
                      <p>
                        反击:
                        <span>{{ user.counter }}</span>
                      </p>
                      <p>
                        破甲:
                        <span>{{ user.armor }}</span>
                      </p>
                      <p>
                        暴击:
                        <span>
                                    {{ (user.criticalHitValue * 100).toFixed(2) || 0 }}%
                                </span>
                      </p>
                      <p>
                        治疗加成:
                        <span>{{ (user.healAdd * 100).toFixed(2) || 0 }} </span>
                      </p>
                      <p>
                        减疗加成:
                        <span>{{ (user.healDeduct * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        增伤加成:
                        <span>{{ (user.damageBoost * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        减伤加成:
                        <span>
                                    {{ (user.damageDeduct * 100).toFixed(2) || 0 }}
                                </span>
                      </p>
                      <p>
                        效果命中:
                        <span>  {{ (user.effectHit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        效果抵抗:
                        <span>{{ (user.effectResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        持续抵抗:
                        <span>{{ (user.susResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        暴击抵抗:
                        <span> {{ (user.criticalResist * 100).toFixed(2) || 0 }}%</span>
                      </p>
                    </div>
                    <div class="basics" style="font-family: Arial,Helvetica,Sans-Serif;">
                      <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" >灵根加成</h6>
                      <p>
                        雷属性加成:
                        <span>{{ (userAura.rayAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        木属性加成:
                        <span>{{ (userAura.woodAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        土属性加成:
                        <span>{{ (userAura.soilAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        火属性加成:
                        <span>{{ (userAura.fireAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        风属性加成:
                        <span>{{ (userAura.windAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        金属性加成:
                        <span>{{ (userAura.metalAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        水属性加成:
                        <span>{{ (userAura.waterAddit * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        冰属性加成:
                        <span>{{ (userAura.iceAddit * 100).toFixed(2) || 0 }}</span>
                      </p>

                      <!--                    <p v-if="realmAttribute.realmAttack">
                                            <Tag><span>真气攻击力：</span>{{(realmAttribute.realmAttack * 100).toFixed(2) || 0 }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmMagicAttack">
                                            <Tag> <span>道法攻击力：</span>{{
                                              (realmAttribute.realmMagicAttack * 100).toFixed(2) || 0
                                            }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmHealth">
                                            <Tag> <span>生命值：</span>{{ (realmAttribute.realmHealth * 100).toFixed(2) || 0 }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmMana">
                                            <Tag> <span>法力值：</span>{{ (realmAttribute.realmMana * 100).toFixed(2) || 0 }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmDefense">
                                            <Tag> <span>防御力：</span>{{ (realmAttribute.realmDefense * 100).toFixed(2) || 0 }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmCriticalHit">
                                            <Tag> <span>暴击率：</span>{{
                                              (realmAttribute.realmCriticalHit * 100).toFixed(2) || 0
                                            }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmCriticalDamage">
                                            <Tag> <span>暴伤率：</span>{{
                                              (realmAttribute.realmCriticalDamage * 100).toFixed(2) ||
                                              0
                                            }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmEvade">
                                            <Tag> <span>闪避率：</span>{{ (realmAttribute.realmEvade * 100).toFixed(2) || 0 }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmHitRat">
                                            <Tag> <span>命中率：</span>{{ (realmAttribute.realmHitRat * 100).toFixed(2) || 0 }}%</Tag>
                                          </p>
                                          <p v-if="realmAttribute.realmSpeed">
                                            <Tag><span>速度率：</span>{{ realmAttribute.realmSpeed || 0 }}</Tag>
                                          </p>-->
                    </div>
                    <div class="basics" style="font-family: Arial,Helvetica,Sans-Serif;">
                      <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" >灵根抗性</h6>
                      <p>
                        雷属性抗性:
                        <span>{{ (user.rayResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        木属性抗性:
                        <span>{{ (user.woodResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        土属性抗性:
                        <span>{{ (user.soilResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        火属性抗性:
                        <span>{{ (user.fireResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        风属性抗性:
                        <span>{{ (user.windResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        金属性抗性:
                        <span>{{ (user.metalResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        水属性抗性:
                        <span>{{ (user.waterResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                      <p>
                        冰属性抗性:
                        <span>{{ (user.iceResist * 100).toFixed(2) || 0 }}</span>
                      </p>
                    </div>
                    <div class="basics" v-if="xinfaBuffer"> <!---->
                      <h6 :style="{ color: this.isActive == false ? '#FFFFFF' : '#949cdd' }" >心法加成</h6>
                      <p >
                        <Tag  v-if="!isActive">真气加成:</Tag>
                        <span  v-if="isActive">真气加成:</span>
                        <span>{{ (xinfaBuffer.attack * 100).toFixed(2) || 0 }}% <Icon type="md-flame" />{{ xinfaBuffer.extraAttack || 0 }}</span>

                      </p>
                      <p>
                        <Tag  v-if="!isActive">道法加成:</Tag>
                        <span  v-if="isActive">道法加成:</span>
                        <span>{{ (xinfaBuffer.magicAttack * 100).toFixed(2) || 0 }}% <Icon type="md-flame" />{{ xinfaBuffer.extraMagic || 0 }}</span>
                      </p>
                      <!--                    <p>-->
                      <!--                      <Tag>道法攻击力:-->
                      <!--                      <span>{{ xinfaBuffer.extraMagic }}</span></Tag>-->
                      <!--                    </p>-->
                      <p>
                        <Tag  v-if="!isActive">生命加成:</Tag>
                        <span  v-if="isActive">生命加成:</span>
                        <span>{{ (xinfaBuffer.healthRatio * 100).toFixed(2) || 0 }}% <Icon type="md-flame" />{{ xinfaBuffer.extraHealth || 0  }}</span>
                      </p>
                      <!--                    <p>
                                            <Tag>生命值:
                                              <span>{{ xinfaBuffer.extraHealth }}</span></Tag>
                                          </p>-->
                      <p>
                        <Tag  v-if="!isActive">法力加成:</Tag>
                        <span  v-if="isActive">法力加成:</span>
                        <span>{{ (xinfaBuffer.manaRatio * 100).toFixed(2) || 0 }}% <Icon type="md-flame" />{{ xinfaBuffer.extraMana || 0  }}</span>
                      </p>
                      <!--                    <p>
                                            <Tag>法力值:
                                              <span>{{ xinfaBuffer.extraMana }}</span></Tag>
                                          </p>-->
                      <p>
                        <Tag  v-if="!isActive">防御加成:</Tag>
                        <span  v-if="isActive">防御加成:</span>
                        <span>{{ (xinfaBuffer.defenseRatio * 100).toFixed(2) || 0 }}% <Icon type="md-flame" />{{ xinfaBuffer.extraDefense || 0  }}</span>
                      </p>
                      <!--                    <p>
                                            <Tag>防御力:
                                            <span>{{ xinfaBuffer.extraDefense }}</span></Tag>
                                          </p>-->
                      <p>
                        <Tag  v-if="!isActive">命中率:</Tag>
                        <span  v-if="isActive">命中率:</span>
                        <span>{{ (xinfaBuffer.hitRatRatio * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        <Tag  v-if="!isActive">闪避率:</Tag>
                        <span  v-if="isActive">闪避率:</span>
                        <span>{{ (xinfaBuffer.evadeRatio * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        <Tag  v-if="!isActive">暴击率:</Tag>
                        <span  v-if="isActive">暴击率:</span>
                        <span>
                                    {{ (xinfaBuffer.criticalHitRation * 100).toFixed(2) || 0 }}%
                                </span>
                      </p>
                      <p>
                        <Tag  v-if="!isActive">暴击伤害:</Tag>
                        <span  v-if="isActive">暴击伤害:</span>
                        <span>{{ (xinfaBuffer.criticalDamageRation * 100).toFixed(2) || 0 }}%</span>
                      </p>
                      <p>
                        <Tag  v-if="!isActive">行动速度:</Tag>
                        <span  v-if="isActive">行动速度:</span>
                        <span>{{ xinfaBuffer.speedRatio }}</span>
                      </p>
                      <p>
                        <Tag  v-if="!isActive">额外伤害:</Tag>
                        <span  v-if="isActive">额外伤害:</span>
                        <span>{{ (xinfaBuffer.extraCon * 100).toFixed(2) || 0 }}%</span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <Poptip word-wrap width="280" >
                      <h4>套装与共鸣 <Icon type="ios-alert-outline" size="20" style="color:#ff8c00;"/></h4>
                      <div slot="content">
                        <p>1.武器决定是什么属性伤害<br>2.武器和灵根匹配对应灵根加成会生效<br>3.装备灵根属性达成多件套也有对应的属性加成 </p>
                      </div>
                    </Poptip>
                    <p v-for="(item, index) in user.suitAndEleList" :key="index">
                      <span>『{{item.name}} 』 </span>
                      <span>{{item.desci}}</span>
                    </p>
                  </div>
                </div>
              </Card>
              <!-- 法器 -->
              <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" >
                <p slot="title">法器</p>
                <div slot="extra">
                  <Button slot="extra" @click.prevent="allTake" size="small" type="info" ghost>
                    一键脱下
                  </Button>
                  <Button slot="extra" @click.prevent="backgroupQie" size="small" type="info" ghost>
                    切换
                  </Button>
                </div>
                <div :class="{ 'parentt': isActive, 'parent': !isActive }"  id="myDiv">
                  <div :class="'div'+(index+1)" v-for="(item, key, index) in equipmentList" :key="index" >
                    <span ><img v-if="index==0"  src="@/assets/jian.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==1"  src="@/assets/yifu.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==2"  src="@/assets/maozi.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==3"  src="@/assets/xianglian.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==4"  src="@/assets/jiezhi.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==5"  src="@/assets/yupei.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==6"  src="@/assets/shoupei.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==7"  src="@/assets/xiezi.png" alt="等待图片加载ing"  width="15" height="15"/>
                    <img v-if="index==8"  src="@/assets/fabao.png" alt="等待图片加载ing"  width="15" height="15"/>{{ key }}:</span>
                    <br>
                    <Poptip trigger="click" v-if="item">
                      <p style="white-space: nowrap; height: 24px;margin-bottom: 10px;" :style="{ color: distinguishColor(item.color) }">
                        {{ item.equitName }}
                        <span v-if="
                      item.itemType != 3 &&
                      item.itemType != 4 &&
                      item.enhanLevel != 0
                    ">
                                        +{{ item.enhanLevel }}
                                    </span>
                      </p>
                      <div slot="content">
                        <p :style="{ color: distinguishColor(item.color) }">
                          {{ item.equitName }}
                          <span v-if="item.itemType != 3 && item.itemType != 4">
                                            +{{ item.enhanLevel }}
                                        </span>
                        </p>
                        <p v-if="item.level">法器等级 <span style="color: #2e8bf0 ">{{ item.level }}</span></p>
                        <p v-if="item.weaponTypeDec">法器元素 <span style="color: #2e8bf0 ">{{ item.weaponTypeDec }}</span></p>
                        <p v-if="item.typeDec">法器类型 <span style="color: #2e8bf0 ">{{ item.typeDec }}</span></p>
                        <p style="color: #515a6e">强化幅度 <span style="color: #2e8bf0 ">{{ (item.enhanRange * 100).toFixed(0) }}%</span> </p>
                        <p>物品状态 <span style="color: #2e8bf0 ">{{ item.bind == 0 ? "解绑" : "绑定" }}</span></p>
                        <p v-if="item.life">
                          生命值 {{ item.life }}
                          <span v-if="item.strengLife">({{ item.strengLife }})</span>
                        </p>
                        <p v-if="item.mana">
                          真气值 {{ item.mana }}
                          <span v-if="item.strengMana">({{ item.strengMana }})</span>
                        </p>
                        <p v-if="item.attack">
                          攻击力 {{ item.attack }}
                          <span v-if="item.strengAttack">
                                            ({{ item.strengAttack }})
                                        </span>
                        </p>
                        <p v-if="item.magAttack">
                          法术攻击力 {{ item.magAttack }}
                          <span v-if="item.strengMagAttack">
                                            ({{ item.strengMagAttack }})
                                        </span>
                        </p>
                        <p v-if="item.defense">
                          物理防御力 {{ item.defense }}
                          <span v-if="item.strengDefense">
                                            ({{ item.strengDefense }})
                                        </span>
                        </p>
                        <p v-if="item.magicDefense">
                          法术防御力 {{ item.magicDefense }}
                          <span v-if="item.strengMagicDefense">
                                            ({{ item.strengMagicDefense }})
                                        </span>
                        </p>
                        <p v-if="item.critical">
                          暴击 {{ (item.critical * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.armor">
                          破甲 {{ (item.armor * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.combo">
                          连击 {{ (item.combo * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.counter">
                          反击 {{ (item.counter * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.hitRate">
                          命中率 {{ (item.hitRate * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.evade">
                          闪避率 {{ (item.evade * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.criticalRegist">
                          暴抗率 {{ (item.criticalRegist * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.criDamage">
                          暴击伤害 {{ (item.criDamage * 100).toFixed(2) }}%
                        </p>
                        <p v-if="item.lucky">
                          福源 {{ item.lucky }}
                        </p>
                        <p v-if="item.speed">行动速度 {{ item.speed }}</p>
                        <p v-if="item.physique">
                          根骨 {{ item.physique }}
                          <span v-if="item.strengPhysique">
                                            ({{ item.strengPhysique }})
                                        </span>
                        </p>
                        <p v-if="item.dexterous">
                          力道 {{ item.dexterous }}
                          <span v-if="item.strengDexterous">
                                            ({{ item.strengDexterous }})
                                        </span>
                        </p>
                        <p v-if="item.spirit">
                          灵力 {{ item.spirit }}
                          <span v-if="item.strengSpirit">
                                            ({{ item.strengSpirit }})
                                        </span>
                        </p>
                        <Divider v-if="item.affixVoList != []" />
                        <template v-if="item.affixVoList">
                          <p v-for="cz in item.affixVoList" :key="cz.affixDescribe" :style="{
                        color: affiexColor(cz.affixLevel) }">
                            {{ cz.affixName }}: {{ cz.affixDescribe }}
                            {{ cz.affixLevel }}
                          </p>
                        </template>
                        <Divider v-if="item.skillDesc" />
                        <CellGroup>
                          <Cell v-if="item.suitName" :title="item.suitName" :label="item.suitDesc" />
                          <!--                          <p v-if="item.suitName">共鸣名字: {{ item.suitName }}</p>-->
                          <!--                          <p v-if="item.suitOneDesc">共鸣效果: {{ item.suitOneDesc }}</p>-->
                          <!--                          <p v-if="item.suitDesc">共鸣描述: {{ item.suitDesc }}</p>-->
                          <Cell v-if="item.suitOneDesc" :title="item.suitOneDesc"  >
                            <template #extra>
                              <Tag color="green">双层共鸣</Tag>
                            </template>
                          </Cell>
                          <Cell v-if="item.suitTwoDesc" :title="item.suitTwoDesc"  >
                            <template #extra>
                              <Tag color="blue">四层共鸣</Tag>
                            </template>
                          </Cell>
                          <Cell v-if="item.suitThreeDesc" :title="item.suitThreeDesc"   >
                            <template #extra>
                              <Tag color="purple">六层共鸣</Tag>
                            </template>
                          </Cell>
                          <p v-if="item.skillDesc">神通描述： {{ item.skillDesc }}</p>
                        </CellGroup>
                        <Button @click.prevent="TakeOffsingleton(item)" icon="ios-hammer" size="small" type="info" ghost>卸下</Button>
                        <Divider v-if="item.equitDec" />
                        <p v-if="item.equitDec" class="Equipment">描述： {{ item.equitDec }}</p>
                      </div>
                    </Poptip>
                  </div>
                  <!--                  <div class="div1">武器</div>
                                    <div class="div2">玄端</div>
                                    <div class="div3">头冠</div>
                                    <div class="div4">项链</div>
                                    <div class="div5">法宝</div>
                                    <div class="div6">绶佩</div>
                                    <div class="div7">绶带</div>
                                    <div class="div8">鞜履</div>
                                    <div class="div9">戒指</div>-->
                  <div class="div10"> </div>
                  <div class="div11"> <!--<img  src="@/assets/帽子.png" alt="等待图片加载ing"  />--> </div>
                </div>
                <!--                <div class="knapsack">
                                  <div v-for="(item, key, index) in equipmentList" :key="index">
                                    <span>{{ key }}:</span>
                                    <Poptip trigger="hover" v-if="item">
                                      <p style="white-space: nowrap; height: 24px;margin-bottom: 10px" :style="{ color: distinguishColor(item.color) }">
                                        {{ item.equitName }}
                                        <span v-if="
                                      item.itemType != 3 &&
                                      item.itemType != 4 &&
                                      item.enhanLevel != 0
                                    ">
                                                        +{{ item.enhanLevel }}
                                                    </span>
                                        <Button @click.prevent="TakeOffsingleton(item)" icon="ios-hammer" size="small" type="info" ghost>脱下</Button>
                                      </p>
                                      <div slot="content">
                                        <p :style="{ color: distinguishColor(item.color) }">
                                          {{ item.equitName }}
                                          <span v-if="item.itemType != 3 && item.itemType != 4">
                                                            +{{ item.enhanLevel }}
                                                        </span>
                                        </p>
                                        <p v-if="item.typeDec">法器类型 <span style="color: #2e8bf0 ">{{ item.typeDec }}</span></p>
                                        <p v-if="item.level">法器等级 <span style="color: #2e8bf0 ">{{ item.level }}</span></p>
                                        <p style="color: #515a6e">强化幅度 <span style="color: #2e8bf0 ">{{ (item.enhanRange * 100).toFixed(2) }}%</span> </p>
                                        <p>物品状态 <span style="color: #2e8bf0 ">{{ item.bind == 0 ? "解绑" : "绑定" }}</span></p>
                                        <p v-if="item.life">
                                          生命值 {{ item.life }}
                                          <span v-if="item.strengLife">({{ item.strengLife }})</span>
                                        </p>
                                        <p v-if="item.mana">
                                          真气值 {{ item.mana }}
                                          <span v-if="item.strengMana">({{ item.strengMana }})</span>
                                        </p>
                                        <p v-if="item.attack">
                                          攻击力 {{ item.attack }}
                                          <span v-if="item.strengAttack">
                                                            ({{ item.strengAttack }})
                                                        </span>
                                        </p>
                                        <p v-if="item.magAttack">
                                          法术攻击力 {{ item.magAttack }}
                                          <span v-if="item.strengMagAttack">
                                                            ({{ item.strengMagAttack }})
                                                        </span>
                                        </p>
                                        <p v-if="item.defense">
                                          防御力 {{ item.defense }}
                                          <span v-if="item.strengDefense">
                                                            ({{ item.strengDefense }})
                                                        </span>
                                        </p>
                                        <p v-if="item.hitRate">
                                          命中率 {{ (item.hitRate * 100).toFixed(2) }}%
                                        </p>
                                        <p v-if="item.evade">
                                          闪避率 {{ (item.evade * 100).toFixed(2) }}%
                                        </p>
                                        <p v-if="item.critical">
                                          暴击率 {{ (item.critical * 100).toFixed(2) }}%
                                        </p>
                                        <p v-if="item.criDamage">
                                          暴击伤害 {{ (item.criDamage * 100).toFixed(2) }}%
                                        </p>
                                        <p v-if="item.lucky">
                                          福源 {{ item.lucky }}
                                        </p>
                                        <p v-if="item.speed">行动速度 {{ item.speed }}</p>
                                        <p v-if="item.physique">
                                          根骨 {{ item.physique }}
                                          <span v-if="item.strengPhysique">
                                                            ({{ item.strengPhysique }})
                                                        </span>
                                        </p>
                                        <p v-if="item.dexterous">
                                          力道 {{ item.dexterous }}
                                          <span v-if="item.strengDexterous">
                                                            ({{ item.strengDexterous }})
                                                        </span>
                                        </p>
                                        <p v-if="item.spirit">
                                          灵力 {{ item.spirit }}
                                          <span v-if="item.strengSpirit">
                                                            ({{ item.strengSpirit }})
                                                        </span>
                                        </p>
                                        <Divider v-if="item.affixVoList != []" />
                                        <template v-if="item.affixVoList">
                                          <p v-for="cz in item.affixVoList" :key="cz.affixDescribe" :style="{
                                        color: affiexColor(cz.affixLevel) }">
                                            {{ cz.affixName }}: {{ cz.affixDescribe }}
                                            {{ cz.affixLevel }}
                                          </p>
                                        </template>
                                        <Divider v-if="item.skillDesc" />
                                        <CellGroup>
                                          <Cell v-if="item.suitName" :title="item.suitName" :label="item.suitDesc" />
                                          &lt;!&ndash;                          <p v-if="item.suitName">共鸣名字: {{ item.suitName }}</p>&ndash;&gt;
                                          &lt;!&ndash;                          <p v-if="item.suitOneDesc">共鸣效果: {{ item.suitOneDesc }}</p>&ndash;&gt;
                                          &lt;!&ndash;                          <p v-if="item.suitDesc">共鸣描述: {{ item.suitDesc }}</p>&ndash;&gt;
                                          <Cell v-if="item.suitOneDesc" :title="item.suitOneDesc"  >
                                            <template #extra>
                                              <Tag color="green">双层共鸣</Tag>
                                            </template>
                                          </Cell>
                                          <Cell v-if="item.suitTwoDesc" :title="item.suitTwoDesc"  >
                                            <template #extra>
                                              <Tag color="blue">四层共鸣</Tag>
                                            </template>
                                          </Cell>
                                          <Cell v-if="item.suitThreeDesc" :title="item.suitThreeDesc"   >
                                            <template #extra>
                                              <Tag color="purple">六层共鸣</Tag>
                                            </template>
                                          </Cell>
                                          <p v-if="item.skillDesc">神通描述： {{ item.skillDesc }}</p>
                                        </CellGroup>
                                        &lt;!&ndash; <Divider v-if="item.equitDec" /> &ndash;&gt;
                                        &lt;!&ndash; <p v-if="item.equitDec">描述： {{ item.equitDec }}</p> &ndash;&gt;
                                      </div>
                                    </Poptip>
                                  </div>
                                </div>-->
              </Card>
              <!--心法技能-->
              <xinfaSkill ></xinfaSkill>
              <Tabs  value="name1" style="width: 100%!important;">
                <TabPane label="储物空间" name="name1" >
                  <Card  :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" >
                    <p slot="title"></p>
                    <div slot="extra">
                          <span>
                              储物空间容量{{ knapsackList.length }} / {{ user.packageNum }}
                          </span>
                      <Button @click.prevent="sellAllEject = true"  size="small" type="success" ghost>
                        出售全部法器
                      </Button>
                      --
                      <Button @click.prevent="refreshPackage"  size="small" type="info" ghost>
                        刷新储物
                      </Button>
                    </div>
                    <div>
                      <div>
                        <p style="line-height: 30px;height: 30px;font-size: 16px;text-align: center">---------法器分类---------</p>
                        <RadioGroup v-model="classification" type="button" button-style="solid">
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >武器</Radio>
                          <Radio label="2"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >玄端</Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >头冠</Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >项链</Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >戒指</Radio>
                          <Radio label="8"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >绶佩</Radio>
                          <Radio label="9"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >绶带</Radio>
                          <Radio label="10"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >鞜履</Radio>
                          <Radio label="11"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >法宝</Radio>
                        </RadioGroup>
                        <p style="line-height: 30px;height: 30px;font-size: 16px;text-align: center">---------法器品质---------</p>
                        <RadioGroup v-model="quality" type="button">
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#8c94a4">破损</Tag></Radio>
                          <Radio label="2"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#879f1e">普通</Tag></Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#078599e0">良品</Tag></Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#036cbee0">上品</Tag></Radio>
                          <Radio label="5"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#801DAE">绝品</Tag></Radio>
                          <Radio label="6"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#9e0e42e0">灵宝</Tag></Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" ><Tag color="#FFA631">秘宝</Tag></Radio>
                        </RadioGroup>
                        <p style="line-height: 30px;height: 30px;font-size: 16px;text-align: center">---------法器属性---------</p>
                        <RadioGroup v-model="element" type="button">
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >金</Radio>
                          <Radio label="2"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >木</Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >水</Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >火</Radio>
                          <Radio label="5"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >土</Radio>
                          <Radio label="6"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >风</Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >雷</Radio>
                          <Radio label="8"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >冰</Radio>
                        </RadioGroup>
                        <p style="line-height: 30px;height: 30px;font-size: 16px;text-align: center">---------法器状态---------</p>
                        <RadioGroup v-model="bind" type="button">
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >全部</Radio>
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >未绑定</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >绑定</Radio>
                        </RadioGroup>
                      </div>
                      <br />
                      <div class="knapsack">
                        <Poptip trigger="hover" transfer offset="-50,20"  padding="10"   v-for="item in filteredItems" :key="item.id" :title="item.name" @on-popper-show="openEquipment(item)" @on-popper-hide="Equipment = null">
                          <p style="white-space: nowrap; height: 24px" :style="{ color: distinguishColor(item.color) }">
                                      <span v-if="item.itemType != 3 && item.itemType != 4">
                                           <Tag  v-if="!isActive">『Lv:{{ item.level }}』</Tag>
                                       <span  style="color: #51629f" v-if="isActive"> 『Lv:{{ item.level }}』</span>
                                      </span>
                            {{ item.itemName }}
                            <!--                      <Tag :color="distinguishColor(item.color)">  {{ item.itemName }}</Tag>-->
                            <span v-if="
                        item.itemType != 3 &&
                        item.itemType != 4 &&
                        item.enhanLevel != 0
                      ">
                                          +{{ item.enhanLevel }}
                                      </span>
                            <span v-if="  item.bind == 1">
                              <Icon type="md-lock" />
                          </span>
                            <span class="jjt_smail" v-if="item.itemType == 3 || item.itemType == 4">
                                          {{ item.itemNum }}
                                      </span>
                            <span v-if="item.weaponTypeDec" >- 『{{ item.weaponTypeDec }}』</span>
                            <br>
                            <!-- icon="ios-construct" -->
                            <Button   @click.prevent="equipmentButton(item)" size="small" v-if="item.itemType != 3 && item.itemType != 4" type="info" ghost>
                              装备
                            </Button>
                            <Button @click.prevent="appraisal(item)" size="small" type="info"  v-if=" (item.kind == 1 || item.kind == 4 || item.kind == 7 || item.kind == 2 || item.kind == 3) && item.appraisal != 1 " ghost>
                              鉴定
                            </Button>
                            <!--                      icon="ios-medical-outline"-->
                            <!--                          <Button @click.prevent="affix(item)" size="small" type="info" v-if="(item.kind == 1 || item.kind == 4 || item.kind == 7) && item.appraisalNum!=0  && item.appraisal == 1 " ghost>
                                                        洗练
                                                      </Button>-->
                            <Button @click.prevent="affix2(item)" size="small" type="info" v-if="(item.kind == 1 || item.kind == 4 || item.kind == 7) && item.appraisalNum!=0  && item.appraisal == 1 " ghost>
                              ✡洗练
                            </Button>
                            <Button @click.prevent="repair(item)" size="small" type="info"  v-if="(item.kind == 1 || item.kind == 4 || item.kind == 7) && item.appraisalNum!=99 " ghost>
                              修复
                            </Button>
                            <Button @click.prevent="strengthen(item)" size="small" type="info"  v-if="item.itemType != 3 && item.itemType != 4 && item.kind != 11 &&  item.enhanLevel != item.maxStrengthen " ghost>
                              强化
                            </Button>
                            <Button @click.prevent="smeltEquit(item)" size="small" type="info"  v-if="item.kind == 11" ghost>
                              熔炼
                            </Button>
                            <Button @click.prevent="changeSect(item)" size="small" type="info"  v-if="(item.color == 5 || item.color == 6)  && item.enhanLevel==0 && item.scoreLevel != null" ghost>
                              捐献
                            </Button>
                            <Button @click.prevent="locking(item)" size="small" type="info" ghost>
                              {{ item.bind == 0 ? "绑定" : "解绑" }}
                            </Button>
                            <!--                      icon="md-pricetags"-->
                            <Button @click.prevent="sellSingle(item)"  size="small" v-if="item.itemType != 3 && item.itemType != 4" type="info" ghost>
                              出售
                            </Button>
                          </p>
                          <div slot="content" class="poptipExplain">
                            <!-- 法器栏显示的数据 -->
                            <div v-if="Equipment" class="Equipment">
                              <p :style="{ color: distinguishColor(Equipment.color) }">
                                {{ Equipment.equitName }}
                                <span v-if="
                            Equipment.itemType != 3 && Equipment.itemType != 4
                          ">
                                                <span style="color: #19be6b ">+{{ Equipment.enhanLevel }}</span>
                                              </span>
                                &nbsp;&nbsp;(已装备)  <br>
                              <p> 灵气:<span style="color: #FFA2D3 "  v-if="Equipment.basicSocre != null ">
                                                ☪{{Equipment.basicSocre }}+{{Equipment.appraisaScore }}
                                              </span></p>
                              <p> 品阶:
                                <span style="color: #FFA2D3 "  v-if="Equipment.scoreLevel != null ">
                                                  {{Equipment.scoreLevel}}
                                              </span>
                              </p>
                              <p style="color: #515a6e">法器等级 <span style="color: #2e8bf0 ">{{ Equipment.level }}</span></p>
                              <p style="color: #515a6e">法器元素 <span style="color: #2e8bf0 ">{{ Equipment.weaponTypeDec }}</span></p>
                              <p style="color: #515a6e">法器类型 <span style="color: #2e8bf0 ">{{ Equipment.typeDec }}</span> </p>
                              <p style="color: #515a6e">强化幅度 <span style="color: #2e8bf0 ">{{ (Equipment.enhanRange * 100).toFixed(2) }}%</span> </p>
                              <p  style="color: #515a6e">物品状态 <span style="color: #2e8bf0 ">{{ Equipment.bind == 0 ? "解绑" : "绑定" }}</span></p>
                              <p v-if="Equipment.life" style="color: #2e8bf0 ">
                                生命值 {{ Equipment.life }}
                                <span style="color: #19be6b " v-if="Equipment.strengLife">
                                                  ({{ Equipment.strengLife }})
                                              </span>
                              </p>
                              <p v-if="Equipment.mana" style="color: #2e8bf0 ">
                                真气值 {{ Equipment.mana }}
                                <span style="color: #19be6b " v-if="Equipment.strengMana">
                                                  ({{ Equipment.strengMana }})
                                              </span>
                              </p>
                              <p v-if="Equipment.attack" style="color: #2e8bf0 ">
                                物攻 {{ Equipment.attack }}
                                <span style="color: #19be6b " v-if="Equipment.strengAttack">
                                                  ({{ Equipment.strengAttack }})
                                              </span>
                              </p>
                              <p v-if="Equipment.magAttack" style="color: #2e8bf0 ">
                                法攻 {{ Equipment.magAttack }}
                                <span style="color: #19be6b " v-if="Equipment.strengMagAttack">
                                                  ({{ Equipment.strengMagAttack }})
                                              </span>
                              </p>
                              <p v-if="Equipment.defense" style="color: #2e8bf0 ">
                                物理防御力 {{ Equipment.defense }}
                                <span style="color: #19be6b " v-if="Equipment.strengDefense">
                                                  ({{ Equipment.strengDefense }})
                                              </span>
                              </p>
                              <p v-if="Equipment.magicDefense" style="color: #2e8bf0 ">
                                法术防御力 {{ Equipment.magicDefense }}
                                <span style="color: #19be6b " v-if="Equipment.strengMagicDefense">
                                                  ({{ Equipment.strengMagicDefense }})
                                              </span>
                              </p>
                              <p v-if="Equipment.critical" style="color: #2e8bf0 ">
                                暴击 {{ (Equipment.critical * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.armor" style="color: #2e8bf0 ">
                                破甲 {{ (Equipment.armor * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.combo" style="color: #2e8bf0 ">
                                连击 {{ (Equipment.combo * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.counter" style="color: #2e8bf0 ">
                                反击 {{ (Equipment.counter * 100).toFixed(2) }}%
                              </p>

                              <p v-if="Equipment.hitRate" style="color: #2e8bf0 ">
                                命中率 {{ (Equipment.hitRate * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.evade" style="color: #2e8bf0 ">
                                闪避率 {{ (Equipment.evade * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.criticalRegist" style="color: #2e8bf0 ">
                                暴抗率 {{ (Equipment.criticalRegist * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.criDamage" style="color: #2e8bf0 ">
                                暴击伤害 {{ (Equipment.criDamage * 100).toFixed(2) }}%
                              </p>
                              <p v-if="Equipment.lucky" style="color: #2e8bf0 ">
                                福源 {{ Equipment.lucky }}
                              </p>
                              <p v-if="Equipment.speed" style="color: #2e8bf0 ">行动速度 {{ Equipment.speed }}</p>
                              <p v-if="Equipment.physique" style="color: #2e8bf0 ">
                                根骨 {{ Equipment.physique }}
                                <span style="color: #19be6b " v-if="Equipment.strengPhysique">
                                                  ({{ Equipment.strengPhysique }})
                                              </span>
                              </p>
                              <p v-if="Equipment.dexterous" style="color: #2e8bf0 ">
                                力道 {{ Equipment.dexterous }}
                                <span style="color: #19be6b " v-if="Equipment.strengDexterous">
                                                  ({{ Equipment.strengDexterous }})
                                              </span>
                              </p>
                              <p v-if="Equipment.spirit" style="color: #2e8bf0 ">
                                灵力 {{ Equipment.spirit }}
                                <span style="color: #19be6b " v-if="Equipment.strengSpirit">
                                                  ({{ Equipment.strengSpirit }})
                                              </span>
                              </p>
                              <Divider v-if="Equipment.affixVoList" />
                              <template v-if="Equipment.affixVoList">
                                <p v-for="cz in Equipment.affixVoList" :key="cz.affixDescribe" :style="{
                            color:  affiexColor(cz.affixLevel)
                          }">
                                  {{ cz.affixName }}: {{ cz.affixDescribe }}
                                  {{ cz.affixLevel }}
                                </p>
                              </template>
                              <Divider v-if="Equipment.equitDec" />
                              <p v-if="Equipment.equitDec" class="Equipment"  style="color: #8b9499" >
                                描述： {{ Equipment.equitDec }}
                              </p>
                              <br>
                              <List  v-if="Equipment.suitName" :header="Equipment.suitName"   >
                                <!--                              <ListItem v-if="Equipment.suitName">共鸣名字: {{ Equipment.suitName }}</ListItem>-->
                                <ListItem v-if="Equipment.suitOneDesc" >『双层共鸣效果』 {{ Equipment.suitOneDesc }}</ListItem>
                                <ListItem v-if="Equipment.suitTwoDesc" >『四层共鸣效果』 {{ Equipment.suitTwoDesc }}</ListItem>
                                <ListItem v-if="Equipment.suitThreeDesc" >『六层共鸣效果』 {{ Equipment.suitThreeDesc }}</ListItem>
                                <!--                              <ListItem v-if="Equipment.suitDesc">共鸣描述: {{ Equipment.suitDesc }}</ListItem>-->
                                <ListItemMeta  :description="Equipment.suitDesc" />
                              </List>
                              <Divider v-if="Equipment.skillDesc" />
                              <p v-if="Equipment.skillDesc" class="Equipment">
                                神通描述： {{ Equipment.skillDesc }}
                              </p>
                            </div>

                            <div>
                              <p :style="{ color: distinguishColor(item.color) }">
                                {{ item.itemName }}
                                <span v-if="item.itemType != 3 && item.itemType != 4">
                                                <span style="color: #19be6b ">+{{ item.enhanLevel }}</span>
                                              </span>
                                <br>
                              <p> 灵气:<span style="color: #FFA2D3 "  v-if="item.basicSocre != null ">
                                                ☪{{item.basicSocre }}+{{item.appraisaScore }}
                                              </span></p>
                              <p> 品阶:
                                <span style="color: #FFA2D3 "  v-if="item.scoreLevel != null ">
                                                  {{item.scoreLevel}}
                                              </span>
                              </p>
                              <p style="color: #515a6e">法器等级 <span style="color: #2e8bf0 ">{{ item.level }}</span></p>
                              <p style="color: #515a6e">法器元素 <span style="color: #2e8bf0 ">{{ item.weaponTypeDec }}</span></p>
                              <p style="color: #515a6e">法器类型 <span style="color: #2e8bf0 ">{{ item.typeDec }}</span></p>
                              <p style="color: #515a6e">强化幅度 <span style="color: #2e8bf0 ">{{ (item.enhanRange * 100).toFixed(2) }}%</span> </p>
                              <p style="color: #515a6e">物品状态 <span style="color: #2e8bf0 ">{{ item.bind == 0 ? "解绑" : "绑定" }}</span></p>
                              <p v-if="item.life" style="color: #2e8bf0 " >
                                生命值 {{ item.life }}
                                <span style="color: #19be6b " v-if="item.strengLife">({{ item.strengLife }})</span>
                                <Tag  color="#FFA2D3" v-if="item.lifeRandom">{{item.lifeRandom}}</Tag>
                              </p>
                              <p v-if="item.mana" style="color: #2e8bf0 " >
                                真气值 {{ item.mana }}
                                <span style="color: #19be6b " v-if="item.strengMana">({{ item.strengMana }})</span>
                                <Tag color="#FFA2D3" v-if="item.manaRandom">{{item.manaRandom}}</Tag>

                              </p>
                              <p v-if="item.attack" style="color: #2e8bf0 " >
                                物攻 {{ item.attack }}
                                <span style="color: #19be6b " v-if="item.strengAttack">({{ item.strengAttack }})</span>
                                <Tag color="#FFA2D3"  v-if="item.attackRandom">{{item.attackRandom}}</Tag>
                              </p>
                              <p v-if="item.magAttack" style="color: #2e8bf0 " >
                                法攻 {{ item.magAttack }}
                                <span style="color: #19be6b " v-if="item.strengMagAttack">({{ item.strengMagAttack }})</span>
                                <Tag color="#FFA2D3"  v-if="item.magAttackRandom">{{item.magAttackRandom}}</Tag>
                              </p>
                              <p v-if="item.defense" style="color: #2e8bf0 " >
                                物理防御力 {{ item.defense }}
                                <span style="color: #19be6b " v-if="item.strengDefense">({{ item.strengDefense }})</span>
                                <Tag color="#FFA2D3"  v-if="item.defenseRandom">{{item.defenseRandom}}</Tag>
                              </p>
                              <p v-if="item.magicDefense" style="color: #2e8bf0 " >
                                法术防御力 {{ item.magicDefense }}
                                <span style="color: #19be6b " v-if="item.strengMagicDefense">({{ item.strengMagicDefense }})</span>
                                <Tag color="#FFA2D3"  v-if="item.magicDefenseRandom">{{item.magicDefenseRandom}}</Tag>
                              </p>
                              <p v-if="item.critical" style="color: #2e8bf0 ">
                                暴击 {{ (item.critical * 100).toFixed(2) }}% <Tag color="#FFA2D3"  v-if="item.criticalRandom">{{item.criticalRandom}}</Tag>
                              </p>
                              <p v-if="item.armor" style="color: #2e8bf0 ">
                                破甲 {{ (item.armor * 100).toFixed(2) }}% <Tag color="#FFA2D3"  v-if="item.armorRandom">{{item.armorRandom}}</Tag>
                              </p>
                              <p v-if="item.combo" style="color: #2e8bf0 ">
                                连击 {{ (item.combo * 100).toFixed(2) }}% <Tag color="#FFA2D3"  v-if="item.comboRandom">{{item.comboRandom}}</Tag>
                              </p>
                              <p v-if="item.counter" style="color: #2e8bf0 ">
                                反击 {{ (item.counter * 100).toFixed(2) }}% <Tag color="#FFA2D3"  v-if="item.counterRandom">{{item.counterRandom}}</Tag>
                              </p>
                              <p v-if="item.hitRate" style="color: #2e8bf0 " >
                                命中率 {{ (item.hitRate * 100).toFixed(2) }}%   <Tag color="#FFA2D3"  v-if="item.hitRateRandom">{{item.hitRateRandom}}</Tag>
                              </p>
                              <p v-if="item.evade" style="color: #2e8bf0 " >
                                闪避率 {{ (item.evade * 100).toFixed(2) }}% <Tag color="#FFA2D3"  v-if="item.evadeRandom">{{item.evadeRandom}}</Tag>
                              </p>
                              <p v-if="item.criticalRegist" style="color: #2e8bf0 " >
                                暴击率 {{ (item.criticalRegist * 100).toFixed(2) }}% <Tag color="#FFA2D3"  v-if="item.criticalRegistRandom">{{item.criticalRegistRandom}}</Tag>
                              </p>
                              <p v-if="item.criDamage" style="color: #2e8bf0 " >
                                暴击伤害 {{ (item.criDamage * 100).toFixed(2) }}%  <Tag color="#FFA2D3"  v-if="item.criDamageRandom">{{item.criDamageRandom}}</Tag>
                              </p>
                              <p v-if="item.speed" style="color: #2e8bf0 " >
                                行动速度 {{ item.speed }} <Tag color="#FFA2D3"  v-if="item.speedRandom">{{item.speedRandom}}</Tag>
                              </p>
                              <p v-if="item.lucky" style="color: #2e8bf0 ">
                                福源 {{ item.lucky }}  <Tag color="#FFA2D3"  v-if="item.luckyRandom">{{item.luckyRandom}}</Tag>
                              </p>
                              <p v-if="item.physique" style="color: #2e8bf0 " >
                                根骨 {{ item.physique }}
                                <span style="color: #19be6b " v-if="item.strengPhysique">
                                                  ({{ item.strengPhysique }})
                                              </span>
                                <Tag color="#FFA2D3"  v-if="item.physiqueRandom">{{item.physiqueRandom}}</Tag>
                              </p>
                              <p v-if="item.dexterous" style="color: #2e8bf0 " >
                                力道 {{ item.dexterous }}
                                <span style="color: #19be6b " v-if="item.strengDexterous">
                                                  ({{ item.strengDexterous }})
                                              </span>
                                <Tag color="#FFA2D3"  v-if="item.dexterousRandom">{{item.dexterousRandom}}</Tag>
                              </p>
                              <p v-if="item.spirit" style="color: #2e8bf0 " >
                                灵力 {{ item.spirit }}
                                <span style="color: #19be6b " v-if="item.strengSpirit">
                                                  ({{ item.strengSpirit }})
                                              </span>
                                <Tag color="#FFA2D3"  v-if="item.spiritRandom">{{item.spiritRandom}}</Tag>
                              </p>
                              <Divider v-if="item.affixVoList" />
                              <template v-if="item.affixVoList">
                                <p v-for="cz in item.affixVoList" :key="cz.affixDescribe" :style="{
                            color:  affiexColor(cz.affixLevel)
                          }">
                                  {{ cz.affixName }}: {{ cz.affixDescribe }}
                                  {{ cz.affixLevel }}
                                </p>
                              </template>
                              <p style="color: #515a6e">鉴定状态 <span style="color: #2e8bf0 ">{{ item.appraisal == 1 ? "已鉴定" : "未鉴定" }}</span> </p>
                              <p style="color: #515a6e">强化上限 <span style="color: #2e8bf0 ">{{  item.maxStrengthen }}</span> </p>
                              <p style="color: #515a6e">洗练上限 <span style="color: #2e8bf0 ">{{ item.appraisalNum }}</span></p>
                              <Divider v-if="item.decs" />
                              <p v-if="item.decs" style="color: #8b9499" class="Equipment">描述： {{ item.decs }}</p>
                              <br>
                              <List  v-if="item.suitName" :header="item.suitName"  >
                                <!--                              <ListItem v-if="Equipment.suitName">共鸣名字: {{ Equipment.suitName }}</ListItem>-->
                                <ListItem v-if="item.suitOneDesc" >『双层共鸣效果』 {{ item.suitOneDesc }}</ListItem>
                                <ListItem v-if="item.suitTwoDesc" >『四层共鸣效果』 {{ item.suitTwoDesc }}</ListItem>
                                <ListItem v-if="item.suitThreeDesc" >『六层共鸣效果』 {{ item.suitThreeDesc }}</ListItem>
                                <!--                              <ListItem v-if="Equipment.suitDesc">共鸣描述: {{ Equipment.suitDesc }}</ListItem>-->
                                <ListItemMeta :description="item.suitDesc" />
                              </List>
                              <!--                            <p v-if="item.suitName">共鸣名字: {{ item.suitName }}</p>
                                                          <p v-if="item.suitOneDesc">双层共鸣效果: {{ item.suitOneDesc }}</p>
                                                          <p v-if="item.suitTwoDesc">四层共鸣效果: {{ item.suitTwoDesc }}</p>
                                                          <p v-if="item.suitThreeDesc">六层共鸣效果: {{ item.suitThreeDesc }}</p>
                                                          <p v-if="item.suitDesc">共鸣描述: {{ item.suitDesc }}</p>-->
                              <Divider v-if="item.skillDesc" />
                              <p v-if="item.skillDesc" class="Equipment">神通描述： {{ item.skillDesc }}</p>
                            </div>
                          </div>
                        </Poptip>
                      </div>
                    </div>
                  </Card></TabPane>
                <TabPane  label="百宝袋" name="name2">
                  <Card  :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" >
                    <p slot="title">百宝袋</p>
                    <div slot="extra">
                      <Button @click.prevent="refreshMaterialPackage" size="small" type="info" ghost>
                        刷新百宝袋
                      </Button>
                      /
                      <Button @click.prevent="arrangement" size="small" type="info" ghost>
                        整理
                      </Button>
                    </div>
                    <div>
                      <div>
                        <p style="line-height: 30px;height: 30px;font-size: 16px;text-align: center">---------物品分类---------</p>
                        <RadioGroup v-model="materialClassification" type="button"  button-style="solid" ><!--:color="cailiaoColor"-->
                          <Radio label="0" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab', border: !isActive ? '1px solid #dcdee2' : '1px solid #9c9cab' }">全部</Radio>
                          <Radio label="3" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">道具</Radio>
                          <Radio label="4" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab'}">材料</Radio>
                          <Radio label="5" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">突破.丹药</Radio>
                          <Radio label="6" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">秘籍.神通</Radio>
                          <Radio label="7" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">强化</Radio>
                          <Radio label="8" :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">活动</Radio>
                          <Radio label="9"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">真灵</Radio>
                          <Radio label="10"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">熔炼</Radio>
                          <Radio label="11"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }" >修复</Radio>
                          <Radio label="12"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">心法</Radio>
                          <Radio label="13"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">宗门</Radio>
                          <Radio label="14"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">图纸</Radio>
                          <Radio label="15"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">锻造材料</Radio>
                        </RadioGroup>
                        <p style="line-height: 30px;height: 30px;font-size: 16px;text-align: center">---------物品品质---------</p>
                        <RadioGroup v-model="materialQuality" type="button">
                          <Radio label="0"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }">全部</Radio>
                          <Radio label="1"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#8c94a4">破损</Tag></Radio>
                          <Radio label="2"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#879f1e">普通</Tag></Radio>
                          <Radio label="3"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#078599e0">良品</Tag></Radio>
                          <Radio label="4"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#036cbee0">上品</Tag></Radio>
                          <Radio label="5"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#801DAE">绝品</Tag></Radio>
                          <Radio label="6"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#9e0e42e0">灵宝</Tag></Radio>
                          <Radio label="7"  :style="{ 'background-color': !isActive ? '#FFFFFF' : '#151728',color: !isActive ? '#515a6e' : '#9c9cab' }"><Tag color="#FFA631">秘宝</Tag></Radio>
                        </RadioGroup>
                      </div>
                      <br />
                      <div class="knapsack">
                        <Poptip trigger="hover" transfer v-for="(item,i) in materialFilteredItems" :key="i" :title="item.name" @on-popper-show="openEquipment(item)" @on-popper-hide="Equipment = null">
                          <p style="white-space: nowrap; height: 24px;padding: 10px 0px" :style="{ color: distinguishColor(item.color) }">
                            <Tag  v-if="!isActive">[{{  baibaoReturnType(item.itemType)  }}]</Tag>
                            <span  style="color: #51629f" v-if="isActive"> 『{{  baibaoReturnType(item.itemType)  }}』</span>

                            <!--                                      <span v-if="item.itemType != 3 && item.itemType != 4 && item.itemType != 6">
                                                                      [LV:{{ item.level }}]
                                                                  </span>-->
                            <Icon :type="baibaoReturnIcon(item.itemType)" /> {{ item.itemName }}

                            <span class="jjt_smail">
                                          * {{ item.itemNum }}
                                      </span>
                            <Button @click.prevent="xiulian(item)" size="small" v-if="item.itemType == 6 || item.itemType == 12" type="info" ghost>
                              修炼
                            </Button>
                            <Button @click.prevent="useItems(item)" size="small" v-if="item.itemType == 3 && item.itemType != 4" type="info" ghost>
                              使用
                            </Button>
                            <Button @click.prevent="upComm(item) " size="small" v-if="user.tradable == 1" type="info" ghost>
                              上架
                            </Button>
                            <Button @click.prevent="hatch(item)" size="small" icon="ios-analytics-outline" v-if="item.itemType == 9" ghost type="info" ghost>
                              孵化
                            </Button>
                            <Button @click.prevent="useItems1(item)" size="small" v-if="item.itemType == 3 && item.itemType != 4" type="info" ghost>
                              批量使用
                            </Button>
                            <Button @click.prevent="discard(item)" size="small"  v-if="item.itemType != 3 && item.itemType != 6" type="info" ghost>
                              丢弃
                            </Button>
                            <!--                      <Button @click.prevent="locking(item)" size="small" type="info" >
                                                    {{ item.bind == 0 ? "绑定" : "解绑" }}
                                                  </Button>-->
                          </p>
                          <div  slot="content" class="poptipExplain" >
                            <div></div>
                            <div class="Equipment">
                              <p :style="{ color: distinguishColor(item.color) }">
                                {{ item.itemName }}
                                <!--                              <span v-if="item.itemType != 3 && item.itemType != 4">
                                                                                  +{{ item.enhanLevel }}
                                                                              </span>-->
                              </p>
                              <p>物品类型 {{ item.typeDec }}</p>
                              <p>物品等级 <span>{{ item.level }}</span></p>
                              <p>物品状态 {{ item.bind == 0 ? "解绑" : "绑定" }}</p>
                              <p v-if="item.itemNum != 1">
                                物品数量： {{ item.itemNum }}
                              </p>
                              <Divider v-if="item.decs" />
                              <p v-if="item.decs" style="color: #535c71; " class="Equipment" >描述： {{ item.decs }}</p>
                            </div>
                          </div>
                        </Poptip>
                      </div>
                    </div>
                  </Card></TabPane>
                <!--            <TabPane label="神通" name="name3"> </TabPane>-->
                <!--              <TabPane label="商店" name="name3">
                                <shop></shop>
                              </TabPane>
                              <TabPane label="活动商店" name="name3">
                                <synthesis></synthesis>
                              </TabPane>-->
              </Tabs>
              <!-- 商店 -->
              <shop></shop>
              <!-- 活动商店 -->
              <div :style="{width:screenWidth }"><synthesis></synthesis></div>
              <!-- 经脉 -->
              <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" style="margin-top: 20px">
                <p slot="title">悟道</p>
                <div slot="extra">
                  <Button slot="extra" @click.prevent="lianhua" size="small" type="info" ghost>
                    炼化
                  </Button>
                </div>
                <div :class="{ 'parent33': isActive, 'parent3': !isActive }"  >
                  <div  style=" width:112px;height:92px;line-height: 90px;text-align: center;" class="div1"> <Tag color="#d88228" >金灵根+{{userAura.metalNum || 0}}</tag> </div>
                  <div  style="  line-height: 90px;text-align: center" class="div2"> <Tag color="#0090ffe0">水灵根+{{userAura.waterNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div3"><Tag color="#9e0e42e0">火灵根+{{userAura.fireNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div4"> <Tag color="#04ad80e0">木灵根+{{userAura.woodNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div5"><Tag color="#473602e0">土灵根+{{userAura.soilNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div6">  <Tag color="#0fb479e0">风灵根+{{userAura.windNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div7"> <Tag color="#6a09f6e0">雷灵根+{{userAura.rayNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div8"> <Tag color="#078599e0">冰灵根+{{userAura.iceNum || 0}}</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div9"> <Tag color="primary">未知</Tag></div>
                  <div  style="  line-height: 90px;text-align: center" class="div10"> <Tag color="primary">未知</Tag></div>
                  <div  style="  display: flex; align-items: center;text-indent: 2em;opacity: 0.9" class="div12">找寻八种灵气即可激活灵根，通过不断使用对应灵气来强化自身的灵根。</div>
<!--                  <div class="div11"> &lt;!&ndash;<img  src="@/assets/帽子.png" alt="等待图片加载ing"  />&ndash;&gt; </div>-->
                </div>
              </Card>
              <!-- 境界突破提示框 -->
              <Modal v-model="realmEject" title="境界突破提示" @on-ok="changeRealm" :styles="{ top: '240px' }">
                <p v-if="breachStuff.realmLevel">
                  突破等级要求: {{ breachStuff.realmLevel }}
                </p>
                <p v-if="breachStuff.realmMaxLevel">
                  突破后等级上限: {{ breachStuff.realmMaxLevel }}
                </p>
                <p v-if="breachStuff.realmName">
                  突破后境界: {{ breachStuff.realmName }}
                </p>
                <p v-if="breachStuff.updateExp">
                  突破消耗修真经验: {{ breachStuff.updateExp }}
                </p>
                <p v-if="breachStuff.realmMaxPro">
                  突破最高概率: {{ breachStuff.realmMaxPro }}
                </p>
                <p v-if="breachStuff.realmDanYaoPro">
                  突破丹药几率: {{ breachStuff.realmDanYaoPro }}
                </p>
                <p v-if="breachStuff.realmDanYaoProTime">
                  突破丹药生效剩余时间(秒): {{ breachStuff.realmDanYaoProTime }}
                </p>
                <p v-if="breachStuff.materOneName">
                  {{ breachStuff.materOneName }}: 需要
                  {{ breachStuff.materOneNum }}
                </p>
                <p v-if="breachStuff.materTwoName">
                  {{ breachStuff.materTwoName }}: 需要
                  {{ breachStuff.materTwoNum }}
                </p>
                <p v-if="breachStuff.materThreeName">
                  {{ breachStuff.materThreeName }}: 需要
                  {{ breachStuff.materThreeNum }}
                </p>
                <p v-if="breachStuff.coin">
                  需要 {{ breachStuff.coninType == 0 ? "金币" : "灵石" }}
                  {{ breachStuff.coin }}
                </p>
              </Modal>

              <!-- 修改名字弹出框 -->
              <Modal title="修改名字" v-model="nameEject" @on-ok="deteSetName" :styles="{ top: '100px' }">
                <Input v-model="userName" placeholder="请输入名字" />
              </Modal>

              <!-- 提升灵根 -->
              <Modal title="灵根提升" v-model="nameEject" @on-ok="deteSetName" :styles="{ top: '100px' }">
                <Input v-model="userName" placeholder="请输入名字" />
              </Modal>

              <!-- 切换地图弹出框 -->
              <Modal title="选择地图" v-model="mapEject" @on-ok="deteSetMap" :styles="{ top: '100px' }">
                <Select v-model="mapName">
                  <!-- ({{ item.minLv }}) -->
                  <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId">
                    {{ item.mapName }}  在线人数： {{ item.onlineNum }}
                  </Option>
                </Select>
              </Modal>
            </div>
            <div id="center">


              <div class="line"></div>

              <!-- 强化提示框 -->
              <Modal v-model="strengthenEject" title="强化提示" @on-ok="changeStrengthen" :styles="{ top: '240px' }" >

                <p v-if="materialsRequired.extraRange">
                  <Divider> <span style="font-size: 18px"> 本次强化幅度为 <Trend flag="up">{{ (materialsRequired.extraRange * 100).toFixed(0) || 0 }}%</Trend> </span></Divider>
                </p>
                <p v-if="materialsRequired.materOneName">
                  <Divider><span ><Icon type="ios-leaf-outline" />  {{materialsRequired.materOneName}} </span> {{ materialsRequired.materOneNum }}</Divider>
                </p>
                <p v-if="materialsRequired.materTwoName">
                  <Divider> <span ><Icon type="ios-leaf-outline" />  {{materialsRequired.materTwoName}} </span>{{ materialsRequired.materTwoNum }}</Divider>
                </p>
                <p v-if="materialsRequired.coin" style="">
                  <Divider> 需要 {{ materialsRequired.coninType == 0 ? "金币" : "灵石" }} {{ materialsRequired.coin }}</Divider>
                </p>
                <p v-if="materialsRequired.enhanceChance">
                  <Divider>强化概率为:{{ (materialsRequired.enhanceChance * 100).toFixed(0) || 0 }}%</Divider>
                </p>
              </Modal>

              <!-- 熔炼提示框 选择材料 -->
              <Modal v-model="smeltEject" title="熔炼选择材料" @on-ok="changeSmelt()" :styles="{ top: '240px' }">
                <!-- 循环展示 Checkbox -->
                <!--                <tr v-for="(item,index) in checkboxList" :key="index"  @on-change="handleCheckboxClick(index)" >-->
                <!--                  <td>-->
                <!--                    <Checkbox  :value="item.packItemId"  :checked="item.checked"-->
                <!--                              @click="handleCheckboxClick(item.packItemId)" > {{ item.itemName }}   *  {{ item.itemNum }}</Checkbox>-->
                <!--                  </td>-->
                <!--                </tr>-->
                <Radio-group v-model="packItemId2">
                  <Radio v-for="(item, index) in checkboxList" :key="index" :label="item.packItemId">
                    {{ item.itemName }}   *  {{ item.itemNum }}
                  </Radio>
                </Radio-group>

              </Modal>
              <!-- 炼化提示框 选择材料或天地灵气 -->
              <Modal v-model="refiningEject" title="炼化选择灵气" @on-ok="changeRefining()" :styles="{ top: '240px' }">
                <Radio-group v-model="packItemId3">
                  <Radio v-for="(item, index) in checkboxList3" :key="index" :label="item.packItemId">
                    {{ item.itemName }}   *  {{ item.itemNum }}
                  </Radio>
                </Radio-group>
              </Modal>

              <Modal v-model="repairEject" title="修复选择灵液" @on-ok="changeRepira()" :styles="{ top: '240px' }">
                <Radio-group v-model="packItemId">
                  <Radio v-for="(item, index) in checkboxList2" :key="index" :label="item.packItemId">
                    {{ item.itemName }}   *  {{ item.itemNum }}
                  </Radio>
                </Radio-group>

              </Modal>


              <!-- 批量使用弹出框 -->
              <Modal width="620" title="批量使用" v-model="batchEject" @on-ok="bulkPurchase()" :styles="{ top: '100px' }">
                <div>
                  <Input v-model="batchNum" type="Number"  placeholder="请输入数量" />
                </div>
              </Modal>

              <Modal v-model="sellAllEject" title="出售" @on-ok="sellAll">
                <p>确定出售全部法器吗，已强化法器不返还强化的金币</p>
              </Modal>
              <!-- 洗练选择词缀 -->
              <Modal v-model="replaceCizEject"  title="洗练选择词缀" ok-text="替换" cancel-text="不替换" @on-ok="replacecizhu(1)" @on-cancel="replacecizhu(2)" :styles="{ top: '100px' }">
                <List :header="item.score"  border size="large" v-for="(item, idx) in replaceCizList" :key="idx" >
                  <ListItem>【{{ item.affixLevel }}】 {{ item.affixName }}: {{ item.affixDescribe }}</ListItem>
                </List>
                <Button @click.prevent="continueCizhu()" size="small" type="info" ghost>
                  继续洗练
                </Button>
              </Modal>
              <!-- 上架商品弹出框 -->
              <Modal width="620" title=" 上架商品" v-model="commEject" @on-ok="upCommBulk()" :styles="{ top: '100px' }">
                <div style="margin: 10px">
                  商品名称： <Input v-model="commName" placeholder="请输入商品名称" />
                </div>
                <div style="margin: 10px">
                  单组数量： <Input v-model="commNum" type="Number"  placeholder="请输入数量" />
                </div>
                <div style="margin: 10px">
                  上架组： <Input v-model="commGroupNum" type="Number"  placeholder="请输入组数量" />
                </div>
                <div style="margin: 10px">
                  售价(灵石)：<Input v-model="commPrice" placeholder="请输入售价" />
                </div>
              </Modal>
            </div>
            <div id="right">
              <div class="line"></div>

            </div>
            <div id="#right2">
            </div>
          </div>
<!--          <div id="box2">

          </div>-->
<!--          <div id="box3">
            <div id="center3">
              <shop></shop>
            </div>
            <div id="right3">
            </div>
          </div>-->
        </div>

    </div>
</template>

<script>

import qs from "query-string";
import vueCanvasNest from "vue-canvas-nest";
import headers from "./headers.vue";
// import playersList from "./playersList.vue";
// import rankingList from "./rankingList.vue";
import shop from "./shop.vue";
import skill from "./skill.vue";
import xinfaSkill from "./xinfaSkill";
import battleProcess from "./battleProcess.vue";
import synthesis from "./synthesis.vue";
import { EquipSlot, SlotName } from "../const";
import { sleep } from "../utils";
import Im from "./Im";
export default {
    name: "index",
    data() {
        return {
            EquipSlot,
            SlotName,
            mapLootsList: [],
            columns: [
              {
                title: '物品品质',
                key: 'ship',
                sortable: true
              },
              {
                title: '物品名称',
                width:'220',
                key: 'itemName'
              },
              {
                title: '物品类型',
                key: 'typeDec'
              },
              {
                title: '物品等级',
                key: 'level'
              }
            ],
            userName: "",
            nameEject: false,
            value2: false,
            collValue: 1,
            mapName: "", // 下拉的地图名字
            mapNameF: "桑林村", // 显示的地图名字
            teamStatus: 0,
            mapEject: false,
            cailiaoColor:"#373e57",
            user: {}, // 用户的全部消息
            userActivity: {}, // 用户的全部活动属性
            userAura: {}, // 用户的全部灵根属性
            mapList: [], // 地图列表
            mapList1: [], // 地图类型区别：1 普通图
            mapList2: [], // 地图列表 2 挑战图
            mapList3: [], // 地图列表 3修真图
            mapList4: [], // 地图列表 4金币图
            mapList5: [], // 地图列表 5活动图
            mapList6: [], // 地图列表 6boss图
            mapList7: [], // 地图列表 7真灵图
            monsterList: [], //怪物信息
            gameCharacterVO: [], // 战斗中人物信息
            gamePetVOList: [], // 战斗中真灵信息
            recording: [], // 战斗信息
            battSuccess: false,
            battleState: false, // 战斗状态
            time: null, // 暂时没用到
            Equipment: undefined, // 法器栏显示
            battleTimer: null,
            knapsackList: [], // 包裹
            palyerNoteList: [], // 包裹
            materialList: [], // 材料包裹
            mapid: null, // 地图id
            activeList: [], // 穿戴的主动神通列表
            passiveList: [], // 穿戴的被动神通列表
            skillList: [], // 全部神通
            equipmentList: {}, //法器列表
            electronicEquipment: false, // 电子设备
            shopList: [], // 商店列表
            classification: "0", // 法器分类
            quality: "0", // 法器品质
            element: "0", // 法器属性
            bind: "0", // 法器绑定
            materialClassification: "3", // 材料分类
            materialQuality: "0", // 材料品质
            strengthenEject: false, // 强化提示框
            screenWidth:"420px",
            smeltEject: false, // 熔炼提示框
            refiningEject: false, // 炼化提示框
            repairEject: false, // 修复提示框
            realmEject: false, // 境界突破提示框
            breachStuff: [], // 突破的材料
            realmColor: "skyblue", // 境界的文字颜色
            realmShadow: "0px 0px 10px #5d5f4d", // 境界的阴影
            withdrawFromActionStatus: false, // 退出战斗的判断
            realmAttribute: "", // 境界加成获取到的属性
            xinfaBuffer: null, // 境界加成获取到的属性
            materialsRequired: {}, // 所需材料
            packItemId: "", // 强化需要用到的
            packItemId2:"",//熔炼需要用到的 熔炼选择的材料
            packItemId3:"",//炼化灵气需要用到的 熔炼选择的灵气或天材地宝
            checkboxList: [], // 熔炼材料包裹
            checkboxList3: [], // 炼化灵气包裹
            checkboxList2: [], // 修复材料包裹
            tuzhiList: [], // 图纸材料包裹
            checkboxValue: false,
            batchNum: "", // 使用物品数量
            commNum: "", // 上架商品数量
            backImg: 1, // 背景图片
            isActive:false, // 切换主体
            commGroupNum: 1, // 上架商品数量
            commName: "", // 上架商品名称
            commPrice: "0",//商品售价
            batchEject: false, // 批量使用的弹出框
            replaceCizEject: false,//替换提示框
            replacePackItem:  {}, //替换法器
            replaceCizList:[],//选择是否替换词缀
            commEject: false, // 上架商品的弹出框
            bgColor: "#e8edf4",//linear-gradient(90deg, #e8edf4 90%,#434343 10%)
            noteFlag:false,

            inputKeyWord: "",
            dropFlag:false,
            settlementjectEject: false, // 结算离线挂机的弹出框
            settlementjectList: {
                countExp: "",
                countItemNum: "",
                countMoney: "",
                outboardTime: "",
                combatNum: "",
                combatSuccessNum: "",
                countSellNum: "",
            }, // 弹出框的离线收益
            sellAllEject: false,
        };
    },
    computed: {
        filteredItems: function () {
            let knapsackList = this.knapsackList.slice(0);
            if (this.classification != 0) {
                knapsackList = knapsackList.filter(
                    (item) => item.kind == this.classification
                );
            }
            if (this.quality != 0) {
                knapsackList = knapsackList.filter(
                    (item) => item.color == this.quality
                );
            }
            if (this.element != 0) {
              knapsackList = knapsackList.filter(
                (item) => item.elment == this.element
              );
            }
            if (this.bind != 3) {
              knapsackList = knapsackList.filter(
                (item) => item.bind == this.bind
              );
            }
            return knapsackList;
        },
        materialFilteredItems: function () {
            let materialList = this.materialList.slice(0);
            if (this.materialClassification != 0) {
                materialList = materialList.filter(
                    (item) => item.itemType == this.materialClassification
                );
            }
            if (this.materialQuality != 0) {
                materialList = materialList.filter(
                    (item) => item.color == this.materialQuality
                );
            }
            return materialList;
        },
    },
    created() {
      setInterval(() => {
        if(this.battSuccess && !this.withdrawFromActionStatus){
          this.battleState = false;
          this.deteSetMap(this.mapid);
        }
      }, 6000);

      const theme = window.localStorage.getItem("isTheme");
      if(theme === "black"){
        this.backImg=0;
        this.isActive=true;
      }else{
        this.backImg=1;
        this.isActive=false;
      }
      const screenWidth = window.innerWidth;
      this.screenWidth=screenWidth+"px";
      // 十五分钟同步一次 角色信息
      setInterval(() => {
        this.updateAllcharacter();
      }, 900000);
    },
    components: { Im, vueCanvasNest, headers, shop, skill,xinfaSkill, synthesis, battleProcess },
    updated() {
        // 战斗记录定位到底部
        const el = document.getElementById("recording");
        const max = el.scrollHeight - el.clientHeight;
        if (max - el.scrollTop < 80) {
            el.scrollTop = el.scrollHeight;
        }
    },
  mounted() {
        // 生成境界的随机颜色
        var roundColor = Math.round(Math.random() * 5);
        if (roundColor == 1) {
            this.realmColor = "red";
        } else if (roundColor == 2) {
            this.realmColor = "skyblue";
        } else if (roundColor == 3) {
            this.realmColor = "orange";
        } else if (roundColor == 4) {
            this.realmColor = "greenyellow";
        } else if (roundColor == 5) {
            this.realmColor = "pink";
        }
        // 如果没有用户id就退出登录
        if (!this.getCookie("userId")) {
            this.$Notice.warning({
              title: '登录提醒',
              desc: '请重新登录'
            });
            this.$router.push({ name: "Login" });
            return;
        }
        // 判断是手机端还是pc端
        if (this._isMobile()) {
            this.electronicEquipment = false;
        } else {
            this.electronicEquipment = true;
        }
        // 如果没有角色id就退出登录
        if (!this.getCookie("charaId")) {
            this.$Notice.warning({title:"请重新登录"});
            this.$router.push({ name: "Login" });
            return;
        }
        this.refreshEquips(); // 获取穿戴的法器列表
        this.refreshUserInfo(); // 获取用户 人物属性
        this.refreshUserInfoCache(); // 获取用户 基本活动属性
        this.queryAuraByCharaId();
        this.MapList();
        //this.refreshPackage(); // 获取全部包裹
        //this.refreshMaterialPackage(); // 获取全部材料包裹
        setTimeout(() => {
            this.$store.commit("edit", this.user);
        }, 600);
        // 兑换码 签到发送过来的
        this.$bus.$on("dhmMsg", (msg) => {
            setTimeout(() => this.refreshPackage(), 500);
            setTimeout(() => this.refreshMaterialPackage(), 500);
        });
        //获取地图掉落
        /*this.$http
        .get("/gameChara/mapDropItems")
        .then((res) => {
          this.mapLootsList = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({title:"获取地图掉落失败");
        });*/
        // 商店购买发送过来的
        this.$bus.$on("shopMsg", (msg) => {
            this.refreshUserInfoCache();
            // this.refreshPackage();
            this.refreshMaterialPackage();
        });
        // 商店批量购买发送过来的
        this.$bus.$on("shopMsg1", (msg) => {
            this.refreshUserInfoCache();
            // this.refreshPackage();
            this.refreshMaterialPackage();
        });
        // 脱下神通发送过来的
        this.$bus.$on("skillMsg", (msg) => {
            this.refreshUserInfo();
            this.refreshUserInfoCache(); // 获取用户 基本活动属性
        });
        // 法器神通发送过来的
        this.$bus.$on("skillMsg1", (msg) => {
            this.refreshUserInfo();
            this.refreshUserInfoCache(); // 获取用户 基本活动属性
        });
        // 退出登录发送过来的
        this.$bus.$on("tcdlMsg", (msg) => {
            this.closeBattleTimer();
        });
        // 有队伍之后才发送的
        this.$bus.$on("teamStatusMsg", (msg) => {
            this.closeBattleTimer();
            this.teamStatus = 1;
            this.TeamMapList();
        });
        // 没队伍之后才发送的
        this.$bus.$on("teamStatusMsg1", (msg) => {
            this.teamStatus = 0;
            this.MapList();
        });
        // 合成之后才发送的
        this.$bus.$on("synthesisMsg", (msg) => {
            this.refreshMaterialPackage();
            //this.refreshPackage();
            this.refreshUserInfoCache();
        });
        // 批量合成之后才发送的
        this.$bus.$on("synthesisMsg1", (msg) => {
            this.refreshMaterialPackage();
            //this.refreshPackage();
            this.refreshUserInfoCache();
        });
        // setTimeout(() => {
        //   if (this.teamStatus == 0) {
        //     this.automaticCombat(); // 自动战斗
        //   }
        // }, 500);
        setTimeout(() => {
            var mapidColor = this.user.accountId + "mapidColor";
            if (window.localStorage[mapidColor]) {
                if (window.localStorage[mapidColormapidColor] == "#666") {
                    this.electronicEquipment = false;
                } else {
                    this.bgColor = window.localStorage[mapidColor];
                    this.electronicEquipment = false;
                }
            }
        }, 500);
    },
    methods: {
        addEightHours(value) {
          const date = new Date(value);
          date.setHours(date.getHours() + 8);
          return date.toISOString().replace("T", " ").substring(0, 19);
        },
        handleCheckSingle(checkedList) {
          checkedList[0];
          // 处理单个 Checkbox 的选中状态
          //this.checkAll = checkedList.length === this.checkboxList.length;
        },
        handleCheckboxClick(index) {
          // 单选逻辑
          this.checkboxList.forEach((item, idx) => {
            if (idx === index) {
              item.checked = true; // 选中当前点击的项
            } else {
              item.checked = false; // 取消其他项的选中状态
            }
          });
        },
        // 修改背景颜色
        changeBg(val) {
            if (this.bgColor != "#666") {
                window.localStorage.setItem(
                    this.user.accountId + "mapidColor",
                    this.bgColor
                );
                this.electronicEquipment = false;
            }
            if (!this.bgColor) {
                this.electronicEquipment = true;
            }
        },
        // 开始离线 结算离线
        reverseOffLine() {
            var mapid;
            for (var i = 0; i < this.mapList.length; i++) {
                if (this.mapName == this.mapList[i].mapName) {
                    var mapid = this.mapList[i].mapId;
                }
            }
            if (!mapid && this.userActivity.online == 0) {
                this.$Notice.warning({title:"请选择离线地图"});
                return;
            }
            if (this.userActivity.online == 0) {
                this.$http
                    .post(
                        "/gameChara/startOffline/?charaId=" +
                        this.getCookie("charaId") +
                        "&mapId=" +
                        mapid
                    )
                    .then((res) => {
                        this.$Notice.warning({title:res.data.msg});
                        this.refreshUserInfo(); // 获取用户 人物属性
                        this.refreshUserInfoCache();
                    })
                    .catch((err) => {
                        this.$Notice.warning({title:"开始离线失败,请联系管理员"});
                    });
            } else if (this.userActivity.online == 1) {
                this.$http
                    .post("/gameChara/endOffline/?charaId=" + this.getCookie("charaId"))
                    .then((res) => {
                        //this.settlementjectList = res.data.data;
                        //this.settlementjectEject = true;
                        this.$Notice.warning({title:res.data.msg});
                        this.refreshUserInfo(); // 获取用户 人物属性
                        this.refreshUserInfoCache();
                    })
                    .catch((err) => {
                        this.$Notice.warning({title:"结算离线失败,请联系管理员"});
                    });
            }
        },
        //
        getRealmAttribute() {
            this.$http
                .post("/gameRealm/getRealmBonus?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.realmAttribute = res.data.data;
                })
                .catch((err) => {
                  this.$Notice.warning({title:err.data.msg});
                });
        },
        addRecord(record) {
            this.recording.push(record);
            // 战斗记录超过一定条数时移除一部分
            if (this.recording.length >= 200) {
                this.recording.splice(0, 100);
            }
        },
        // 获取地图列表
        MapList() {
            this.$http.get("gameChara/queryMapList").then((res) => {
                this.mapList = res.data.data;
               /* for (let i = 0; i <  this.mapList.length; i++) {
                  if (this.mapList[i].mapType == 1) {
                     //普通地图
                     this.mapList1.push(this.mapList[i]);
                  } else if (this.mapList[i].mapType == 2) {
                     //挑战地图
                    this.mapList2.push(this.mapList[i]);
                  } else if (this.mapList[i].mapType == 3) {
                     //修真地图
                    this.mapList3.push(this.mapList[i]);
                  } else if (this.mapList[i].mapType == 4) {
                     //金币图
                    this.mapList4.push(this.mapList[i]);
                  } else if (this.mapList[i].mapType == 5) {
                     //活动图
                    this.mapList5.push(this.mapList[i]);
                  } else if (this.mapList[i].mapType == 6) {
                    //boss
                    this.mapList6.push(this.mapList[i]);
                  } else if (this.mapList[i].mapType == 7) {
                    //真灵图
                    this.mapList7.push(this.mapList[i]);
                  }
                }*/
            });
        },
        // 获取地图列表
        palyerNote2() {
          if(this.mapLootsList.length === 0){
            this.$http
              .get("/gameChara/mapDropItems")
              .then((res) => {
                this.mapLootsList = res.data.data;
              })
              .catch((err) => {
                this.$Notice.warning({title:"获取地图掉落失败"});
              });
          }
        },
        palyerNote() {
          this.$http
            .post("gamepassport/palyerNote?charaId=" + this.getCookie("charaId")+"&keyword="+this.inputKeyWord)
            .then((res) => {
              this.palyerNoteList = res.data.data;
                for (let i = 0; i <  this.palyerNoteList.length; i++) {
                  if (this.palyerNoteList[i].noteType == 1) {
                    this.palyerNoteList[i].color= "green";
                  } else if (this.palyerNoteList[i].noteType == 2) {
                    this.palyerNoteList[i].color=  "red";
                  } else if (this.palyerNoteList[i].noteType == 3) {
                    this.palyerNoteList[i].color=  "blue";
                  } else if (this.palyerNoteList[i].noteType == 4) {
                    this.palyerNoteList[i].color=  "#ff8c00";
                  } else if (this.palyerNoteList[i].noteType == 5) {
                    this.palyerNoteList[i].color =  "#ff00e0";
                  }  else {
                    this.palyerNoteList[i].color =  "#ff00c3e0";
                  }
                }

            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //加成
        sectBuff() {
          this.$http
            .get(
              "/gameSect/getSectXinfaList/?charaId=" +
              this.getCookie("charaId")
            )
            .then((res) => {
              //this.$Notice.success({title:res.data.msg});
              this.xinfaBuffer=res.data.data;
            }).catch((err) => {
              this.$Notice.warning({title:"无心法加成"});
           });
        },
        // 获取组队地图列表
        TeamMapList() {
            this.$http.get("/gameAmry/queryMapList").then((res) => {
                this.mapList = res.data.data;
            });
        },
        // // 自动战斗
        // automaticCombat() {
        //   // 如果地图id存在就自动战斗
        //   var mapid = this.user.accountId + "mapid";
        //   var mapName = this.user.accountId + "mapName";
        //   if (window.localStorage[mapid]) {
        //     this.mapName = window.localStorage[mapName];
        //     this.mapNameF = window.localStorage[mapName];
        //     this.deteSetMap(window.localStorage[mapid]);
        //   }
        // },
        // 返回品质颜色
        distinguishColor(color) {
            if (color == 1) {
              if(this.isActive){
                return "#8c94a4";
              }else{
                return "#000";
              }
            } else if (color == 2) {
                return "#879f1e";
            } else if (color == 3) {
                return "#078599e0";
            } else if (color == 4) {
                return "#036cbee0";
            } else if (color == 5) {
                return "#6a09f6e0";
            } else if (color == 6) {
                return "#ff0028e0";
            } else if (color == 7) {
                return "#ff8c00";
            } else {
                return "#ff00c3e0";
            }
        },
        // 返回道具分类
        baibaoReturnType(type) {
          if (type == 9) {
            return "真灵蛋";
          } else if (type == 10) {
            return "熔炼";
          } else if (type == 11) {
            return "修复";
          } else if (type == 13) {
            return "宗门信物";
          } else if (type == 7) {
            return "强化";
          } else if (type == 6 || type == 12) {
            return "秘籍";
          } else if (type == 4) {
            return "材料";
          }else if (type == 3) {
            return "道具";
          } else {
            return "其他";
          }
        },
      // 返回道具图标
      baibaoReturnIcon(type) {
        if (type == 9) {
          return "ios-analytics-outline";
        } else if (type == 10) {
          return "md-flask"; //熔炼<Icon type="md-flask" />
        } else if (type == 11) {
          return "md-flask";//修复
        } else if (type == 13) {
          return "";//宗门信物<Icon type="ios-bookmark-outline" />
        } else if (type == 7) {
          return "ios-construct";//强化<Icon type="ios-construct" />
        } else if (type == 6) {
          return "md-bookmarks";//秘籍<Icon type="ios-bookmarks-outline" />
        } else if (type == 4) {
          return "ios-leaf-outline";//材料<Icon type="ios-leaf" /><Icon type="ios-leaf-outline" />
        }else if (type == 3) {
          return "ios-cube-outline";
        } else {
          return "md-flame";
        }
      },
        // 返回词缀颜色
        affiexColor(color) {
          if (color == 'T1') {
            return "#ff8c00";
          } else if (color == 'T2') {
            return "purple";
          } else {
            return "rgb(73, 193, 248)";
          }
        },
        // 炼化 天才地宝和灵气
        lianhua() {
          this.refiningEject = true;
        },
        //炼化 的确定
        changeRefining() {
          this.$http
            .post(
              "/gameCharaEquip/refiningAuraBypackage?charaId=" +
              this.getCookie("charaId") +
              "&packItemId=" +
              this.packItemId3
            )
            .then((res) => {
              this.refreshMaterialPackage(); // 获取全部材料包裹
              this.refreshUserInfo();
              this.refreshUserInfoCache(); // 获取用户 基本活动属性
              this.queryAuraByCharaId();
              this.$Notice.success({title:res.data.data});
            })
            .catch((err) => {
              this.$Notice.warning({title:"炼化灵气失败,请联系管理员"});
            });
        },
        backgroupQie() {
          var i = this.backImg;
          // 假设你有一个div元素的ID为"myDiv"
          var div = document.getElementById("myDiv");
          if(i === 1){
            div.className = "parentt"; // 为div赋予新的类
            this.backImg=0;
            this.isActive=true;
            window.localStorage.setItem("isTheme","black");
          }else{
            div.className = "parent"; // 为div赋予新的类
            this.backImg=1;
            this.isActive=false;
            window.localStorage.setItem("isTheme","white");
          }
          this.$Notice.warning({title:"已切换"});
          window.location.reload();
        },
        // 一键脱下
        allTake() {
            this.$http
                .post(
                    "/gameCharaEquip/oneDownEquitBypackage?charaId=" +
                    this.getCookie("charaId")
                )
                .then((res) => {
                    this.$Notice.warning({title:res.data.data});
                    this.refreshUserInfo(); // 获取用户
                    this.refreshUserInfoCache(); // 获取用户 基本活动属性
                    this.refreshEquips(); // 获取穿戴的法器列表
                    this.refreshPackage(); // 获取全部包裹
                })
                .catch((err) => {
                  this.$Notice.warning({title:err.data.msg});
                });
        },
       /* getRecordButtonImage() {
          if (this.recordState) {
            return "backgroundImage:url(" + stopRecord + ");";
          } else {
            return "backgroundImage:url(" + startRecord + ");";
          }
        },*/
  // 判断是手机端还是pc端
        _isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
        },
        // 返回数据处理的法器列表
        getEquipMap(player) {
            for (let i = 0; i < player.length; i++){
              if(player[i].geKind === 1){
                this.$store.commit("setWeaponType", player[i].weaponType);
              }
            }
            const equips = {};
            Object.values(this.EquipSlot).map((slotId) => {
                equips[this.SlotName[slotId]] = player.find(
                    (item) => item.geKind === slotId
                );
            });
            return equips;
        },
        // 头像上传
        handleUpload(file) {
            var image = new FormData();
            image.append("file", file);
            this.$http
                .post(
                    "/gamepassport/uploadFace/?charaId=" + this.getCookie("charaId"),
                    image,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                )
                .then((res) => {
                    this.refreshUserInfoCache();
                    this.$Notice.warning({title:res.data.msg});
                });
            return false;
        },
        // 获取角色的法器列表
        refreshEquips() {
            this.$http
                .post(
                    "gameCharaEquip/getCharaEquip?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    this.equipmentList = this.getEquipMap(res.data.data);
                    console.log(res.data.data);
                })
                .catch((err) => {
                  this.$Notice.warning({title:err.data.msg});
                });
        },
        // 获取角色的全部消息
        refreshUserInfo() {
            this.$http
                .get(
                    "gamepassport/getGameCharacter?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    this.user = res.data.data;
                    this.user.charaId = this.getCookie("charaId");
                    // console.log(this.user);
                })
                .catch((err) => {
                    this.$Notice.warning({title:"获取角色失败,请联系管理员"});
                });
        },
        // 获取角色的全部消息 有缓存
        refreshUserInfoCache() {
            this.$http
                .get(
                    "/gamepassport/getGameCharacterActivity?charaId=" +
                    this.getCookie("charaId")
                )
                .then((res) => {
                    //this.user.accountId = res.data.data.accountId;
                    this.userActivity.coin = res.data.data.coin;
                    this.userActivity.exp = res.data.data.exp;
                    this.userActivity.level = res.data.data.level;
                    this.userActivity.face = res.data.data.face;
                    //this.user.id = res.data.data.id;
                    this.userActivity.money = res.data.data.money;
                    this.userActivity.packageNum = res.data.data.packageNum;
                    this.userActivity.realmExp = res.data.data.realmExp;
                    this.userActivity.rewardNum = res.data.data.rewardNum;
                    this.userActivity.activityRewardNum = res.data.data.activityRewardNum;
                    this.userActivity.mapName = res.data.data.mapName;
                    this.userActivity.online = res.data.data.online;
                    this.userActivity.upgradeExp = res.data.data.upgradeExp;
                    let biLi = this.userActivity.exp / this.userActivity.upgradeExp;
                    this.userActivity.baifbi = Number(biLi.toFixed(2));
                    this.userActivity.contriPoint = res.data.data.contriPoint;

                    this.userActivity.outboardMonNum = res.data.data.outboardMonNum;
                    this.userActivity.outboardTime = res.data.data.outboardTime;
                  this.userActivity.outboardDate = res.data.data.outboardDate;
                    this.userActivity.outboardExp = res.data.data.outboardExp;
                    this.userActivity.attNum = res.data.data.attNum;
                    this.userActivity.successNum = res.data.data.successNum;
                    this.userActivity.dropItem = res.data.data.dropItem;
                    this.userActivity.outboardMap = res.data.data.outboardMap;
                    //this.user.charaId = this.getCookie("charaId");
                    this.getRealmAttribute();
                    this.sectBuff();
                })
                .catch((err) => {
                    this.$Notice.warning({title:"获取角色失败,请联系管理员"});
                });
        },
        queryAuraByCharaId() {
          this.$http
            .post(
              "/gameChara/queryAuraByCharaId?charaId=" +
              this.getCookie("charaId")
            )
            .then((res) => {
              this.userAura = res.data.data;
            });
        },
        // 获取用户全部法器包裹
        refreshPackage() {
            this.$http
                .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.knapsackList = res.data.data;
                    //console.log(res.data.data);
                    this.$Notice.info({title:"成功获取"});
                })
                .catch((err) => {
                    this.$Notice.warning({title:"获取法器包裹失败,请联系管理员"});
                });
        },
        /*// 获取用户全部法器包裹
        refreshPackage2() {
          this.$http
            .post("gameChara/getCharaPackage?charaId=" + this.getCookie("charaId"))
            .then((res) => {
              this.knapsackList = res.data.data;
              this.$Notice.success({title:res.data.msg});
            })
            .catch((err) => {
              this.$Notice.warning({title:"获取法器包裹失败,请联系管理员"});
            });
        },*/
        // 获取用户全部材料包裹
        refreshMaterialPackage() {
            this.$http
                .post(
                    "/gameChara/getCharaMaterial/?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    this.materialList = res.data.data;
                    //checkboxList
                    this.knapsackList = [];
                    this.checkboxList = [];
                    this.checkboxList2 = [];
                    this.checkboxList3 = [];
                    //锻造材料传输
                    this.tuzhiList = [];
                    for (let i = 0; i < this.materialList.length; i++) {
                      if(this.materialList[i].itemType == 10 ){
                        this.checkboxList.push(this.materialList[i]);
                      }
                      if(this.materialList[i].itemType == 11 ){
                        this.checkboxList2.push(this.materialList[i]);
                      }
                      if(this.materialList[i].itemType == 14 ){
                        this.tuzhiList.push(this.materialList[i]);
                      }
                      if(this.materialList[i].itemType == 16 ){
                        this.checkboxList3.push(this.materialList[i]);
                      }
                    }
                  this.$store.commit("setZhuList", this.tuzhiList);
                  this.$store.commit("setMaterialList", this.materialList);
                  console.log( this.tuzhiList);
                })
                .catch((err) => {
                    this.$Notice.warning({title:"获取材料包裹失败,请联系管理员"});
                });
        },
      xuanzhong(value){
        this.mapName=value;
        this.mapNameF=value;
        this.battleState=false;
        this.$Notice.warning({title:"已选中"});
        this.value2=false;
      },
      // 获取用户全部材料包裹
      refreshMaterialPackage2() {
        this.$http
          .post(
            "/gameChara/getCharaMaterial/?charaId=" + this.getCookie("charaId")
          )
          .then((res) => {
            this.materialList = res.data.data;
            //checkboxList
            this.checkboxList = [];
            this.checkboxList2 = [];
            for (let i = 0; i < this.materialList.length; i++) {
              if(this.materialList[i].itemType == 10 ){
                this.checkboxList.push(this.materialList[i]);
              }
              if(this.materialList[i].itemType == 11 ){
                this.checkboxList2.push(this.materialList[i]);
              }
            }
            this.$Notice.success({title:res.data.msg});
          })
          .catch((err) => {
            this.$Notice.warning({title:"获取材料包裹失败,请联系管理员"});
          });
      },
        // 修改名字的按钮
        editName() {
            this.userName = "";
            this.nameEject = true;
        },
      signIn() {
        this.$http
          .post(
            "/gamepassport/signInDaily?charaId=" +
            this.getCookie("charaId") +
            "&signType=" +
            1
          )
          .then((res) => {
            this.$Notice.warning(res.data.data || res.data.msg);
          })
          .catch((err) => {
            this.$Notice.warning({title:"签到失败,请联系管理员"});
          });

        this.$bus.$emit("dhmMsg", "兑换码 签到那里发送过来的");
      },
        // 修改名字弹出框的确定
        deteSetName() {
            this.$http
                .post(
                    "gamepassport/updataGameName?charaId=" +
                    this.getCookie("charaId") +
                    "&name=" +
                    this.userName
                )
                .then((res) => {
                    this.$Notice.success({title:"修改成功"});
                })
                .catch((err) => {
                    this.$Notice.warning({title:"修改名字失败"});
                });
            this.user.name = this.userName;
        },
        // 切换地图的按钮
        changeMap() {
            this.mapEject = true;
        },
        // 退出战斗
        withdrawFromAction() {
            this.withdrawFromActionStatus = true;
        },
        // 关闭战斗定时
        closeBattleTimer() {
            clearTimeout(this.battleTimer);
            this.battleTimer = null;
        },
        // 切换地图弹出框的确定
        async deteSetMap(mapid) {
            if (!this.mapName) {
                this.$Notice.warning({title:"请选择地图"});
                return;
            }
            if (this.battleState) {
                this.$Notice.warning({title:"还在战斗状态 不能切换"});
                return;
            }
            if (this.withdrawFromActionStatus) {
                this.withdrawFromActionStatus = false;
                return;
            }
            this.mapNameF = this.mapName;
            this.mapid = mapid;
            for (var i = 0; i < this.mapList.length; i++) {
                if (this.mapName == this.mapList[i].mapName) {
                    this.mapid = this.mapList[i].mapId;
                }
            }
            // 存进locastorange做自动战斗
            window.localStorage.setItem(this.user.accountId + "mapid", this.mapid);
            window.localStorage.setItem(
                this.user.accountId + "mapName",
                this.mapName
            );
            // 是否是游戏副本
            const isInstanceZones = this.teamStatus !== 0;
            //this.$Notice.warning({title:"开始战斗"});
            // 副本使用不同的战斗接口
            let combatAddress = isInstanceZones
                ? "/gameAmry/checkMapGenMon"
                : "/gameChara/checkMapGenMon";
            try {
                const res = await this.$http.post(
                    `${combatAddress}?${qs.stringify({
                        charaId: this.getCookie("charaId"),
                        mapId: this.mapid,
                    })}`
                );
                if (res.data.msg != 'OK') {
                    this.$Notice.warning({title:res.data.msg});
                    return
                }
                const body = res.data;
                // 判断他有没有战斗结束就重新调用接口
                if (body.status == 205) {
                    this.closeBattleTimer();
                    this.$Notice.warning(body.msg);
                    await sleep(6000);
                    this.battleState = false;
                    this.deteSetMap(mapid);
                    return;
                }
                this.battleState = true;
                this.battSuccess = false;
                // 非副本战斗返回的结果是一个直接的对象，这里转换成一样的结构
                const combatResults = isInstanceZones ? body.data : [body.data];
                // 按顺序播报所有的战斗结果
                for (let i = 0; i < combatResults.length; i++) {
                    await this.boardcastCombatResult(combatResults[i]);
                }
                this.battleState = false;
            } catch (err) {
                console.log(err);
                this.$Notice.warning({title:"战斗开始失败6秒后自动请求战斗,原因："+res.data.msg});
            }
            this.battleTimer = setTimeout(() => {
                this.battleState = false;
                this.deteSetMap(mapid);
            }, 6500);
        },
        // 播报战斗返回的日志
        async boardcastCombatResult(result) {
            this.monsterList = result.gameMonList; // 怪物信息
            this.monsterList.forEach((m) => (m.maxLife = m.life));
            if (this.teamStatus != 1) {
              this.gamePetVOList = result.gamePetVO; // 真灵信息
              this.gamePetVOList.forEach((m) => (m.maxLife = m.auraLife));

              this.gameCharacterVO = [result.gameCharacterVO]; // 人物加信息
              this.gameCharacterVO.forEach((m) => (m.maxLife = m.health));
            }
            let combatInfo = result.combatInfo;
            for (let i = 0; i < combatInfo.length; i++) {
                // 每条记录的输出相隔 1.5 秒
                await sleep(1500);
                const record = combatInfo[i];
                const targets = this.monsterList.filter(
                    (m) => m.name == record.hinjured
                );
                if (targets.length > 0) {
                    targets[0].life = record.surplusHealth;
                }
                const targets2 = this.gamePetVOList.filter(
                  (m) => m.auraName == record.hinjured
                );
                if (targets2.length > 0) {
                  targets2[0].auraLife = record.surplusHealth;
                }
                if (this.teamStatus != 1) {
                    const targets1 = this.gameCharacterVO.filter(
                        (m) => m.name == record.hinjured
                    );
                    if (targets1.length > 0) {
                        targets1[0].health = record.surplusHealth;
                    }
                }
                // 1 物理伤害 2灵力伤害 3持续伤害 4恢复血量
                // console.log(record, "战斗日志");
                if (record.hurtType == 5) {
                    record.type = "gain";
                } else {
                    record.type = "combat";
                }
                this.addRecord(record);
            }
            // 额外增加一个战斗结果的消息记录
            if (result.reHealth <= 0) {
                this.addRecord({
                    type: "result",
                    result: "战斗失败",
                });
                this.battSuccess=true;
            } else {
                // 物品列表
                const goods = result.gameItemsList.map((val) => {
                    return val.itemName;
                });
                const droppedGood = goods.length > 0;
                this.addRecord({
                    type: "result",
                    result: "战斗成功",
                    exp: "获得" + result.dropExp + "经验;",
                    goods: "物品:" + (droppedGood ? goods.join() : "无"),
                    reHealth: result.reHealth,
                    reMana: result.reMana,
                });
                if (droppedGood) {
                    this.refreshPackage();
                    this.refreshMaterialPackage();
                    // 通知神通刷新检查
                    this.$bus.$emit("getSkillMsg");
                }
                this.battSuccess=true;
                this.refreshUserInfo();
                //this.refreshUserInfoCache();
            }
        },
        updateAllcharacter(){
          //this.refreshUserInfo(); // 获取用户 人物属性
          this.refreshUserInfoCache(); // 获取用户 基本活动属性
          this.$Notice.success({title:"同步成功"});
        },
        // 确认修改属性的按钮
        setAttribute() {
            this.user.charaId = this.getCookie("charaId");
            this.$http
                .post("gameChara/updateAttrPoint", this.user)
                .then((res) => {
                    this.$Notice.warning({title:"修改成功"});
                    this.refreshUserInfo();
                    this.refreshUserInfoCache(); // 获取用户 基本活动属性
                })
                .catch((err) => {
                    this.$Notice.warning({title:"修改失败,请联系管理员"});
                });
        },
        // 属性加点
        addAttributes(val, spot) {
            if (this.user.reAttrPoint <= 0) {
                this.$Notice.warning({title:"没有属性点可加了"});
                return;
            }
            if (this.user.reAttrPoint < spot) {
                this.$Notice.warning({title:"属性点不够了凹"});
                return;
            }
            if (val == 0) {
                this.user.physique += spot;
            } else if (val == 1) {
                this.user.dexterous += spot;
            } else if (val == 2) {
                this.user.spirit += spot;
            }
            this.user.reAttrPoint -= spot;
        },
        // 显示法器对比属性
        openEquipment(item) {
            for (let key in this.equipmentList) {
                if (!this.equipmentList[key]) continue
                if (item.kind == this.equipmentList[key].geKind) {
                    this.Equipment = this.equipmentList[key];
                }
            }
        },
        // 整理物品失败
        arrangement() {
            this.$http
                .post(
                    "/gameChara/arrangeCharaMaterial?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    this.$Notice.warning({title:res.data.msg});
                    this.refreshMaterialPackage();
                    this.materialClassification = "0";
                    this.quality = "0";
                })
                .catch((err) => {
                    this.$Notice.warning({title:"整理物品失败,请联系管理员"});
                });
        },
        // 出售全部法器
        sellAll() {
            let arrKnapsac = [];
            this.filteredItems.forEach((val) => {
                arrKnapsac.push(val.packItemId);
            });
            this.$http
                .post(
                    "gameCharaEquip/oneClickSale?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemIds=" +
                    arrKnapsac
                )
                .then((res) => {
                    this.refreshUserInfoCache();
                    this.refreshPackage();
                    // 每次出售完 就退到2个全部
                    this.classification = "0";
                    this.materialQuality = "0";
                })
                .catch((err) => {
                    this.$Notice.warning({title:"出售全部物品失败,请联系管理员"});
                });
        },
        // 鉴定法器
        appraisal(item) {
            this.$http
                .post(
                    "/gameCharaEquip/appraisalEquitBypackage?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    item.packItemId
                )
                .then((res) => {
                    this.refreshUserInfoCache();
                    this.refreshPackage();
                    // 每次出售完 就退到2个全部
                    this.$Notice.success({title:res.data.data});
                })
                .catch((err) => {
                    this.$Notice.warning({title:err.data.data});
                });
        },
        // 洗词缀
        affix(item) {
            this.$http
                .post(
                    "/gameCharaEquip/useEquitBySuccinct?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    item.packItemId
                )
                .then((res) => {
                    this.refreshUserInfoCache();
                    this.refreshPackage();
                    // 每次出售完 就退到2个全部
                    this.$Notice.success({title:res.data.data});
                })
                .catch((err) => {
                   this.$Notice.warning({title:err.data.data});
                });
        },
        // 洗词缀替换
        affix2(item) {
          this.$http
            .post(
              "/gameCharaEquip/useEquitBySuccinct2?charaId=" +
              this.getCookie("charaId") +
              "&equipItemId=" +
              item.itemId
            )
            .then((res) => {
              this.refreshUserInfoCache();
              this.refreshMaterialPackage(); // 获取全部材料包裹
              this.refreshPackage();
              // res.data.data
              this.replaceCizEject = true;
              this.replacePackItem =  item;
              this.replaceCizList = res.data.data;
              for (var i = 0; i < this.replaceCizList.length; i++) {
                this.replaceCizList[i].score ="灵气 ☪"+this.replaceCizList[i].score;
              }
              this.$Notice.success({title:"成功"});
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        // 脱下单件法器
        TakeOffsingleton(item) {
            this.$http
                .post(
                    "/gameCharaEquip/downEquitBypackage?charaId=" +
                    this.getCookie("charaId") +
                    "&equitId=" +
                    item.equitId
                )
                .then((res) => {
                    this.refreshEquips();
                    this.refreshUserInfo();
                    this.refreshUserInfoCache(); // 获取用户 基本活动属性
                    this.refreshPackage();
                    this.$Notice.success({title:res.data.data});
                })
                .catch((err) => {
                   this.$Notice.warning({title:err.data.data});
                });
        },
        // 出售单件法器
        sellSingle(item) {
            if (item.enhanLevel >= 1) {
                this.$http
                    .post(
                        "gameCharaEquip/useEquitByDecompose?charaId=" +
                        this.getCookie("charaId") +
                        "&packItemIds=" +
                        item.packItemId
                    )
                    .then((res) => {
                        this.$Notice.success({title:res.data.data});
                        this.refreshUserInfoCache();
                        this.refreshPackage();
                    })
                    .catch((err) => {
                      this.$Notice.warning({title:err.data.data});
                    });
            } else {
                this.$http
                    .post(
                        "gameCharaEquip/oneClickSale?charaId=" +
                        this.getCookie("charaId") +
                        "&packItemIds=" +
                        item.packItemId
                    )
                    .then((res) => {
                        this.refreshUserInfoCache();
                        this.refreshPackage();
                    })
                    .catch((err) => {
                        this.$Notice.warning({title:"出售单件物品失败,请联系管理员"});
                    });
            }
        },
        // 物品使用按钮
        useItems(item) {
            this.$http
                .post(
                    "/gameCharaEquip/usePropypackage?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    item.packItemId +
                    "&useNum=" +
                    1
                )
                .then((res) => {
                    this.$Notice.success({title:res.data.data});
                    // this.refreshEquips();
                    this.refreshMaterialPackage();
                    this.refreshUserInfoCache();
                    this.refreshUserInfo(); // 获取用户 人物属性
                })
                .catch((err) => {
                    this.$Notice.warning({title:err.data.msg});
                });
        },
        xiulian(item) {
          this.$http
            .post(
              "/gameCharaSkill/charaLearnSkill?charaId=" +
              this.getCookie("charaId") +
              "&packageItem=" +
              item.packItemId
            )
            .then((res) => {
              this.$Notice.success({title:res.data.data});
              this.refreshMaterialPackage();
              this.getAllSkill();
              //this.getEquipmentSkill();
              // this.refreshEquips();
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //上架
        upComm(item) {
          this.commEject = true;
          this.packItemId = item.packItemId;
        },
        //上架的确认
        upCommBulk(item) {
          this.$http
            .post(
              "/gameBussiness/playersConsignmentItem?charaId=" +
              this.getCookie("charaId") +
              "&buyName=" +
              this.commName +
              "&packItemId=" +
              this.packItemId +
              "&price=" +
              this.commPrice +
              "&goodNum=" +
              this.commNum+
              "&goodGroupNum=" +
              this.commGroupNum
            )
            .then((res) => {
              this.$Notice.success({title:res.data.msg});
              // this.refreshEquips();
              this.refreshMaterialPackage();
              this.refreshUserInfoCache();
              //this.refreshUserInfo(); // 获取用户 人物属性
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        // 孵化
        hatch(item) {
            this.$http
                .post(
                    "/gameAura/hatchPet?charaId=" +
                    this.getCookie("charaId") +
                    "&packId=" +
                    item.packItemId
                )
                .then((res) => {
                    this.$Notice.success({title:res.data.msg});
                    // this.refreshEquips();
                    this.refreshMaterialPackage();
                    this.refreshUserInfoCache();
                })
                .catch((err) => {
                    this.$Notice.warning({title:err.data.msg});
                });
        },
        // 批量使用按钮
        useItems1(item) {
            this.batchEject = true;
            this.packItemId = item.packItemId;
        },
        // 丢弃
        discard(item) {
            this.$http
                .post(
                    "/gameCharaEquip/oneClickDrop?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemIds=" +
                    item.packItemId +
                    "&packItemNum=" +
                    1
                )
                .then((res) => {
                    this.$Notice.success({title:res.data.msg});
                    this.refreshMaterialPackage();
                    this.refreshUserInfoCache();
                })
                .catch((err) => {
                    this.$Notice.warning({title:"丢弃失败,请联系管理员"});
                });
        },
        // 批量使用的确定
        bulkPurchase() {
            this.$http
                .post(
                    "/gameCharaEquip/usePropypackage?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    this.packItemId +
                    "&useNum=" +
                    this.batchNum
                )
                .then((res) => {
                    this.$Notice.warning({title:res.data.msg});
                    // this.refreshEquips();
                    this.refreshMaterialPackage();
                    this.refreshUserInfoCache();
                    this.refreshUserInfo(); // 获取用户 人物属性
                })
                .catch((err) => {
                    this.$Notice.warning({title:"使用失败,请联系管理员"});
                });
        },
        // 法器界面上的装备按钮
        equipmentButton(item) {
            this.$http
                .post(
                    "gameCharaEquip/useEquitBypackage?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    item.packItemId
                )
                .then((res) => {
                    this.$Notice.warning({title:res.data.data});
                    this.refreshEquips();
                    /*const index = this.knapsackList.indexOf(item);
                    if (index !== -1) {
                      this.knapsackList.splice(index,1);
                    }*/
                    this.refreshPackage();
                    this.refreshUserInfo();
                    this.refreshUserInfoCache(); // 获取用户 基本活动属性
                })
                .catch((err) => {
                    this.$Notice.warning({title:err.data.data});
                });
        },
        // 法器界面上的强化按钮
        strengthen(item) {
            this.strengthenEject = true;
            this.packItemId = item.packItemId;
            this.$http
                .post(
                    "/gameCharaEquip/getCaiEquitStrengThen?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    item.packItemId
                )
                .then((res) => {
                    this.materialsRequired = res.data.data;
                })
                .catch((err) => {
                    this.$Notice.warning({title:"强化材料失败,请联系管理员"});
                });
        },
        //法器界面上的熔炼按钮
        repair(item) {
          this.repairEject = true;
          this.packItemId2 = item.packItemId;
        },

        //法器界面上的熔炼按钮
        smeltEquit(item) {
          this.smeltEject = true;
          this.packItemId = item.packItemId;
        },
        changeSect(item) {
          this.$http
            .post(
              "/gameSect/playersConsignWare?charaId=" +
              this.getCookie("charaId") +
              "&packId=" +
              item.packItemId
            )
            .then((res) => {
              this.$Notice.success({title:res.data.msg});
              this.refreshPackage(); // 获取全部包裹
              this.refreshUserInfo();
              this.refreshUserInfoCache(); // 获取用户 基本活动属性
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //修复的确定
        changeRepira() {
          this.$http
            .post(
              "/gameCharaEquip/useEquitPropypackage?charaId=" +
              this.getCookie("charaId") +
              "&packItemId=" +
              this.packItemId+
              "&packItemId2=" +
              this.packItemId2
            )
            .then((res) => {
              this.refreshPackage(); // 获取全部包裹
              this.refreshMaterialPackage(); // 获取全部材料包裹
              this.$Notice.success({title:res.data.data});
            })
            .catch((err) => {
              this.$Notice.warning({title:"修复材料失败,请联系管理员"});
            });
        },
        continueCizhu(){
          this.replacecizhu2(2);
        },
        replacecizhu2(index){
          //replaceEquitSkill
          this.$http
            .post(
              "/gameCharaEquip/replaceEquitSkill?charaId=" +
              this.getCookie("charaId") +
              "&equipItemId=" +
              this.replacePackItem.itemId+
              "&type=" +
              index
            )
            .then((res) => {
              this.refreshPackage(); // 获取全部包裹
              this.refreshMaterialPackage(); // 获取全部材料包裹
              this.affix2(this.replacePackItem)
              this.$Notice.success({title:res.data.data});
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //替换词缀
        replacecizhu(index){
          //replaceEquitSkill
          this.$http
            .post(
              "/gameCharaEquip/replaceEquitSkill?charaId=" +
              this.getCookie("charaId") +
              "&equipItemId=" +
              this.replacePackItem.itemId+
              "&type=" +
              index
            )
            .then((res) => {
              this.refreshPackage(); // 获取全部包裹
              this.refreshMaterialPackage(); // 获取全部材料包裹
              this.$Notice.success({title:res.data.data});
            })
            .catch((err) => {
              this.$Notice.warning({title:err.data.msg});
            });
        },
        //熔炼的确定
        changeSmelt() {
          this.$http
            .post(
              "/gameCharaEquip/smeltEquitBypackage?charaId=" +
              this.getCookie("charaId") +
              "&packItemId=" +
              this.packItemId+
              "&packItemId2=" +
              this.packItemId2
            )
            .then((res) => {
              this.refreshPackage(); // 获取全部包裹
              this.refreshMaterialPackage(); // 获取全部材料包裹
              this.refreshUserInfo();
              this.refreshUserInfoCache(); // 获取用户 基本活动属性
              this.$Notice.success({title:res.data.data});
            })
            .catch((err) => {
              this.$Notice.warning({title:"熔炼材料失败,请联系管理员"});
            });
        },
        // 强化提示的确定
        changeStrengthen() {
            this.$http
                .post(
                    "/gameCharaEquip/equitStrengThen?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    this.packItemId
                )
                .then((res) => {
                    this.$Notice.warning({title:res.data.msg});
                    this.refreshPackage();
                    this.refreshUserInfo();
                    this.refreshUserInfoCache(); // 获取用户 基本活动属性
                })
                .catch((err) => {
                    this.$Notice.warning({title:"强化失败,请联系管理员"});
                });
        },
        // 突破按钮
        breach() {
            this.realmEject = true;
            this.$http
                .post("/gameRealm/getCaiRealm?charaId=" + this.getCookie("charaId"))
                .then((res) => {
                    this.breachStuff = res.data.data;
                })
                .catch((err) => {
                    this.$Notice.warning({title:"突破获取材料失败,请联系管理员"});
                });
        },
        // 境界突破确定
        changeRealm() {
            this.$http
                .post(
                    "/gameRealm/breakThroughTheRealm?charaId=" + this.getCookie("charaId")
                )
                .then((res) => {
                    this.$Notice.warning({title:res.data.msg});
                    this.refreshUserInfo(); // 获取用户
                    this.refreshUserInfoCache(); // 获取用户 基本活动属性
                    this.refreshPackage(); // 获取全部包裹
                })
                .catch((err) => {
                    this.$Notice.warning({title:"突破失败,请联系管理员"});
                });
        },
        // 法器界面上的锁定按钮
        locking(item) {
            this.$http
                .post(
                    "/gameMarket/itemBind?charaId=" +
                    this.getCookie("charaId") +
                    "&packItemId=" +
                    item.packItemId +
                    "&bind=" +
                    (item.bind == 0 ? 1 : 0)
                )
                .then((res) => {
                    this.$Notice.success({title:res.data.data});
                    this.refreshPackage();
                })
                .catch((err) => {
                    this.$Notice.warning({title:"绑定失败,请联系管理员"});
                });
        },
    },
};
</script>
<style>
#app {
    height: 100%;
}
#app2 {
    font-family: Helvetica;
    height: 100%;
    overflow: auto;
}
.vue-canvas-nest-element {
    opacity: 0.9 !important;
}
.vue-canvas-nest-element canvas {
    background: rgba(0, 0, 0, 0.9);
    opacity: 1 !important;
}
.ivu-card {
    background: rgba(255, 255, 255, 1);
}
.ivu-card-head {
    border-bottom: 0px solid #abb6c0 !important;
}
/* 为了头像宽度 */
.ivu-card-body .ivu-avatar {
    width: 100px;
    height: 100px;
    float: left;
}
/* 为了每一个卡片都往下15px */
.ivu-card-bordered {
    margin-bottom: 15px;
}
</style>

<style scoped>
/* 全局样式 */
.two {
    position: absolute;
    width: 73.6%;
    height: 485px;
}
.three {
  position: relative;
  width: 760px;
  height: 385px;
}
.line {
    height: 500px;
}
#app2 {
    min-width: 1140px;
}
#app3 {
  width: 99%;
  /*1240px*/
  margin: 0 auto;
  border-radius: 4px;
  /*background: #f5f7f9;*/
}
#box {
    width: 99%;
  /*1140*/
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: relative;
}
#box2 {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}
#box4{
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}
#box3 {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}
#left{
  width: 25%;
}
#right
 {
  width: 95%;
    /* background-color: skyblue; */
}
#center{
  width:  95%;
}
#center3{
  width: 95%;
  /* background-color: skyblue; */
}
* {
  font-family: '思源黑体', sans-serif ;
}
#right3 {
  width: 95%;
  /* background-color: skyblue; */
}
/* 第一块位置 用户头像那一块*/
.character {
    overflow: hidden;
}
.character /deep/ .ivu-upload-drag {
    float: left;
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
.touxiang {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: cover;
}
.rank {
    float: left;
    margin-left: 20px;
}
.rank div {
    overflow: hidden;
}
.rank div > span {
    background-color: #a1afb4;
    color: #fff;
    padding: 1px 3px;
    border-radius: 4px;
}
.bloodVolume,
.blueAmount {
    width: 280px;
    height: 22px;
    background: #ee0056e0;
    border-radius: 5px;
    color: #fff;
    font-size: 12px;
    line-height: 22px;
    text-align: center;
}
.bloodVolume {
    margin-top: 10px;
    margin-bottom: 10px;
}
.blueAmount {
    background: #0090ffe0;
}
.goldCoin {
    border-top: 1px dashed #999;
    margin-top: 12px;
    padding-top: 8px;
}
.goldCoin p {
    margin-top: 2px;
}
/* 地图和战斗场景 */
.monster {
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 40px; */
    margin-bottom: 8px;
    margin-top: 8px;
}
.monstercenter {
    justify-content: center;
}
/* 为了给提示设置 颜色 */
/deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-inner {
    background-color: rgba(70, 76, 91, 0.9);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
/deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-arrow:after {
    border-top-color: rgba(70, 76, 91, 0.9);
}
/deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title {
  background: #FFFFFF;
}
/deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title-inner {
  background: #FFF;
   /* color: #fff;*/
}
/deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-body {
   /* color: #fff;*/
  background: #FFF;
}
/*  战斗场景  */
.recording {
    max-height: 254px;
    overflow: auto;
    transition: all 0.4s;
}
/* 头像下面 基础属性 和 加点的位置*/
.basics {
    width: 33%;
    height: 400px;
    float: left;
}
.basics2 {
  width: 66%;
}
.basics h6 {
    background-color: #6e44c0;
    color: #fff;
    padding: 1px 3px;
    border-radius: 4px;
    display: inline-block;
    margin-bottom: 12px;
}
.basics p {
    margin-bottom: 4px;
}
.basics p button {
    background-color: #d9534f;
    color: #fff;
    padding: 1px 4px;
    border-radius: 4px;
    border: 0;
    outline: none;
    font-size: 12px;
    margin-right: 3px;
    margin-left: 1px;
    cursor: pointer;
}
.blackBackGroupButton{
  background-color: #151728;
  border: 1px solid #9c9cab;
  color: #9c9cab;
}

.blackBackGroup{
  background-color: #151728;
  border: none;
  color: #9c9cab;
}
.blackBackGroup .ivu-card-head p, .ivu-card-head-inner{
  color: #4975d4;
}

.blackBackGroup span{
  background-color: #151728;
  color: #9c9cab;
}
.blackBackGroup .ivu-tag-text{
  color: #6983bc !important;
}
.blackBackGroup2{

}
/* knapsack 储物空间 */
.knapsack {
   max-width: 426px;
/*"Helvetica Neue",Helvetica,"","Hiragino Sans GB","Microsoft YaHei","\5FAE\8F6F\96C5\9ED1",Arial,sans-serif*/
  /*font-family: "PingFang SC";*/
}
.knapsack /deep/ .ivu-poptip-popper,
.equipmentBar /deep/ .ivu-poptip-popper {
    pointer-events: none;
}
.knapsack /deep/ .ivu-poptip {
    width: 80%;
}
.knapsack /deep/ .ivu-poptip p button {
    visibility: hidden;
    height: 22px;
}
.knapsack /deep/ .ivu-poptip p:hover {
    z-index: 9;
    position: relative;
}
.knapsack /deep/ .ivu-poptip p:hover button {
  visibility: visible;
}
.knapsack /deep/ .ivu-poptip p button:hover {
  color: darkorange;
  /*color: #FFA2D3;*/
}
.jjt_smail {
    color: #b50111;
    font-size: 12px;
}
/* 法器栏数据对比显示 */
.Equipment {
    width: 200px;
    white-space: normal;
    word-break: break-all;
    margin-right: 15px;
}
.Equipment + div {
    width: 200px;
    white-space: normal;
    word-break: break-all;
}
.ivpopper2 {
  top: 200px!important;
}
/* 法器栏数据对比显示左右对比数据显示 */
.poptipExplain {
    display: flex;
}
/* 调整文字颜色 */
.poptipExplain div p {
    color: rgb(73, 193, 248);
}
.poptipExplain div p span {
    color: rgb(0, 255, 55);
}
.poptipExplain div p:nth-child(1),
.poptipExplain div p:nth-child(2),
.poptipExplain div p:nth-child(3),
.poptipExplain div p:nth-child(4) {
    color: inherit;
}
/* 境界属性带来的提升 */
.realmAttribute p span {
    color: rgb(45, 196, 255);
}
.parent {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background-image: url('../assets/dazuo2.png');
  background-size: cover;
  background-repeat:no-repeat;
  background-position: center;
}
.parentt{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background-image: url('../assets/dazou.png');
  background-repeat:no-repeat;
  background-position: center;
}
.div1 { grid-area: 1 / 1 / 2 / 2; }
.div2 { grid-area: 2 / 1 / 3 / 2; }
.div3 { grid-area: 3 / 1 / 4 / 2; }
.div4 { grid-area: 4 / 1 / 5 / 2; }
.div5 { grid-area: 1 / 4 / 2 / 5; }
.div6 { grid-area: 2 / 4 / 3 / 5; }
.div7 { grid-area: 3 / 4 / 4 / 5; }
.div8 { grid-area: 4 / 4 / 5 / 5; }
.div9 { grid-area: 5 / 1 / 6 / 2; }
.div10 { grid-area: 5 / 4 / 6 / 5; }
.div11 { grid-area: 1 / 2 / 6 / 4; }
.div12 { grid-area: 1 / 2 / 2 / 4; }
.parent3{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  border: 1px solid #abb6c0;
  background-image: url('../assets/jingmai3.png');
  background-size: cover;
  background-repeat:no-repeat;
  background-position: center;
}
.parent33{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  border: 1px solid #373e57;
  background-size: cover;
  background-repeat:no-repeat;
  background-position: center;
}


.parent1 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.parent1 div:hover{
  border: 2px solid #88DD11 !important;
}
.ddiv1 { grid-area: 1 / 1 / 2 / 2; }
.ddiv2 { grid-area: 1 / 2 / 2 / 3; }
.ddiv3 { grid-area: 1 / 3 / 2 / 4; }
.ddiv4 { grid-area: 1 / 4 / 2 / 5; }
.ddiv5 { grid-area: 2 / 1 / 3 / 2; }
.ddiv6 { grid-area: 2 / 2 / 3 / 3; }
.ddiv7 { grid-area: 2 / 3 / 3 / 4; }
.ddiv8 { grid-area: 2 / 4 / 3 / 5; }
.ddiv9 { grid-area: 3 / 1 / 4 / 2; }
.ddiv10 { grid-area: 3 / 2 / 4 / 3; }
.ddiv11 { grid-area: 3 / 3 / 4 / 4; }
.ddiv12 { grid-area: 3 / 4 / 4 / 5; }
.ddiv13 { grid-area: 4 / 1 / 5 / 2; }
.ddiv14 { grid-area: 4 / 2 / 5 / 3; }
.ddiv15 { grid-area: 4 / 3 / 5 / 4; }
.ddiv16 { grid-area: 4 / 4 / 5 / 5; }
.ddiv17 { grid-area: 5 / 1 / 6 / 2; }
.ddiv18 { grid-area: 5 / 2 / 6 / 3; }
.ddiv19 { grid-area: 5 / 3 / 6 / 4; }
.ddiv20 { grid-area: 5 / 4 / 6 / 5; }
</style>




// WEBPACK FOOTER //
// src/components/indexMobile.vue